$wj([37],{

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1744), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1751), exports);
tslib_1.__exportStar(__webpack_require__(1563), exports);
tslib_1.__exportStar(__webpack_require__(1564), exports);
tslib_1.__exportStar(__webpack_require__(671), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var DialogContent_types_1 = __webpack_require__(671);
var Button_1 = __webpack_require__(62);
var DialogFooter_1 = __webpack_require__(1564);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogContent = /** @class */ (function (_super) {
    tslib_1.__extends(DialogContent, _super);
    function DialogContent(props) {
        return _super.call(this, props) || this;
    }
    DialogContent.prototype.render = function () {
        var _a = this.props, showCloseButton = _a.showCloseButton, closeButtonAriaLabel = _a.closeButtonAriaLabel, onDismiss = _a.onDismiss, subTextId = _a.subTextId, subText = _a.subText, titleId = _a.titleId, title = _a.title, type = _a.type;
        var groupings = this._groupChildren();
        var subTextContent;
        if (subText) {
            subTextContent = React.createElement("p", { className: Utilities_1.css('ms-Dialog-subText', styles.subText), id: subTextId }, subText);
        }
        var contentClassName = Utilities_1.css(this.props.className, (_b = {},
            _b['ms-Dialog--lgHeader ' + styles.isLargeHeader] = type === DialogContent_types_1.DialogType.largeHeader,
            _b['ms-Dialog--close ' + styles.isClose] = type === DialogContent_types_1.DialogType.close,
            _b));
        return (React.createElement("div", { className: Utilities_1.css(contentClassName) },
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-header', styles.header) },
                React.createElement("p", { className: Utilities_1.css('ms-Dialog-title', styles.title), id: titleId, role: 'heading' }, title),
                React.createElement("div", { className: Utilities_1.css('ms-Dialog-topButton', styles.topButton) },
                    this.props.topButtonsProps.map(function (props) { return (React.createElement(Button_1.IconButton, tslib_1.__assign({}, props))); }),
                    (type === DialogContent_types_1.DialogType.close || (showCloseButton && type !== DialogContent_types_1.DialogType.largeHeader)) &&
                        React.createElement(Button_1.IconButton, { className: Utilities_1.css('ms-Dialog-button ms-Dialog-button--close', styles.button), iconProps: { iconName: 'Cancel' }, ariaLabel: closeButtonAriaLabel, onClick: onDismiss }))),
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-inner', styles.inner) },
                React.createElement("div", { className: Utilities_1.css('ms-Dialog-content', styles.content, this.props.className) },
                    subTextContent,
                    groupings.contents),
                groupings.footers)));
        var _b;
    };
    // @TODO - typing the footers as an array of DialogFooter is difficult because
    // casing "child as DialogFooter" causes a problem because
    // "Neither type 'ReactElement<any>' nor type 'DialogFooter' is assignable to the other."
    DialogContent.prototype._groupChildren = function () {
        var groupings = {
            footers: [],
            contents: []
        };
        React.Children.map(this.props.children, function (child) {
            if (typeof child === 'object' && child !== null && child.type === DialogFooter_1.DialogFooter) {
                groupings.footers.push(child);
            }
            else {
                groupings.contents.push(child);
            }
        });
        return groupings;
    };
    DialogContent.defaultProps = {
        showCloseButton: false,
        className: '',
        topButtonsProps: [],
        closeButtonAriaLabel: 'Close'
    };
    DialogContent = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], DialogContent);
    return DialogContent;
}(Utilities_1.BaseComponent));
exports.DialogContent = DialogContent;
//# sourceMappingURL=DialogContent.js.map

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogFooter = /** @class */ (function (_super) {
    tslib_1.__extends(DialogFooter, _super);
    function DialogFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFooter.prototype.render = function () {
        return (React.createElement("div", { className: Utilities_1.css('ms-Dialog-actions', styles.actions) },
            React.createElement("div", { className: Utilities_1.css('ms-Dialog-actionsRight', styles.actionsRight) }, this._renderChildrenAsActions())));
    };
    DialogFooter.prototype._renderChildrenAsActions = function () {
        return React.Children.map(this.props.children, function (child) {
            return child && React.createElement("span", { className: Utilities_1.css('ms-Dialog-action', styles.action) }, child);
        });
    };
    return DialogFooter;
}(Utilities_1.BaseComponent));
exports.DialogFooter = DialogFooter;
//# sourceMappingURL=DialogFooter.js.map

/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1752), exports);
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 1742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1562), exports);
var index_1 = __webpack_require__(1562);
exports.default = index_1.Dialog;
//# sourceMappingURL=Dialog.js.map

/***/ }),

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1560), exports);
var index_1 = __webpack_require__(1560);
exports.default = index_1.Modal;
//# sourceMappingURL=Modal.js.map

/***/ }),

/***/ 1744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var index_1 = __webpack_require__(674);
var Overlay_1 = __webpack_require__(675);
var Layer_1 = __webpack_require__(331);
var index_2 = __webpack_require__(599);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(1745);
var styles = stylesImport;
var Modal = /** @class */ (function (_super) {
    tslib_1.__extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            id: Utilities_1.getId('Modal'),
            isOpen: props.isOpen,
            isVisible: props.isOpen,
        };
        return _this;
    }
    Modal.prototype.componentWillReceiveProps = function (newProps) {
        clearTimeout(this._onModalCloseTimer);
        // Opening the dialog
        if (newProps.isOpen) {
            if (!this.state.isOpen) {
                // First Open
                this.setState({
                    isOpen: true
                });
            }
            else {
                // Reopen during closing
                this.setState({
                    isVisible: true
                });
            }
        }
        // Closing the dialog
        if (!newProps.isOpen && this.state.isOpen) {
            this._onModalCloseTimer = this._async.setTimeout(this._onModalClose, parseFloat(styles.duration) * 1000);
            this.setState({
                isVisible: false
            });
        }
    };
    Modal.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!prevProps.isOpen && !prevState.isVisible) {
            this.setState({
                isVisible: true
            });
        }
    };
    Modal.prototype.render = function () {
        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, onDismiss = _a.onDismiss, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, titleAriaId = _a.titleAriaId, subtitleAriaId = _a.subtitleAriaId;
        var _b = this.state, isOpen = _b.isOpen, isVisible = _b.isVisible;
        var modalClassName = Utilities_1.css('ms-Modal', styles.root, this.props.className, !!isOpen && 'is-open', !!isVisible && styles.rootIsVisible);
        if (!isOpen) {
            return null;
        }
        // @temp tuatology - Will adjust this to be a panel at certain breakpoints
        if (responsiveMode >= withResponsiveMode_1.ResponsiveMode.small) {
            return (React.createElement(Layer_1.Layer, { onLayerDidMount: onLayerDidMount },
                React.createElement(index_2.Popup, { role: isBlocking ? 'alertdialog' : 'dialog', ariaLabelledBy: titleAriaId, ariaDescribedBy: subtitleAriaId, onDismiss: onDismiss },
                    React.createElement("div", { className: modalClassName },
                        React.createElement(Overlay_1.Overlay, { isDarkThemed: isDarkOverlay, onClick: isBlocking ? undefined : onDismiss }),
                        React.createElement(index_1.FocusTrapZone, { componentRef: this._resolveRef('_focusTrapZone'), className: Utilities_1.css('ms-Dialog-main', styles.main, this.props.containerClassName), elementToFocusOnDismiss: elementToFocusOnDismiss, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap ? isClickableOutsideFocusTrap : !isBlocking, ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector }, this.props.children)))));
        }
        return null;
    };
    Modal.prototype.focus = function () {
        this._focusTrapZone && this._focusTrapZone.focus();
    };
    // Watch for completed animations and set the state
    Modal.prototype._onModalClose = function () {
        this.setState({
            isOpen: false
        });
        // Call the onDismiss callback
        if (this.props.onDismissed) {
            this.props.onDismissed();
        }
    };
    Modal.defaultProps = {
        isOpen: false,
        isDarkOverlay: true,
        isBlocking: false,
        className: '',
        containerClassName: '',
    };
    Modal = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], Modal);
    return Modal;
}(Utilities_1.BaseComponent));
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map

/***/ }),

/***/ 1745:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_561423dc{background-color:transparent;position:fixed;height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;opacity:0;pointer-events:none;-webkit-transition:opacity .267s;transition:opacity .267s}.root_561423dc .ms-Button.ms-Button--compound{display:block}[dir='ltr'] .root_561423dc .ms-Button.ms-Button--compound{margin-left:0}[dir='rtl'] .root_561423dc .ms-Button.ms-Button--compound{margin-right:0}@media screen and (-ms-high-contrast: active){.root_561423dc .ms-Overlay{opacity:0}}.rootIsVisible_561423dc{opacity:1;pointer-events:auto}.main_561423dc{background-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;outline:3px solid transparent;max-height:100%;overflow-y:auto}[dir='ltr'] .main_561423dc{-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,0.4);box-shadow:0 0 5px 0 rgba(0,0,0,0.4)}[dir='rtl'] .main_561423dc{-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,0.4);box-shadow:0 0 5px 0 rgba(0,0,0,0.4)}[dir='ltr'] .main_561423dc{text-align:left}[dir='rtl'] .main_561423dc{text-align:right}\n" }]);
exports.duration = ".267s";
exports.root = "root_561423dc";
exports.rootIsVisible = "rootIsVisible_561423dc";
exports.main = "main_561423dc";
//# sourceMappingURL=Modal.scss.js.map

/***/ }),

/***/ 1751:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var DialogContent_types_1 = __webpack_require__(671);
var Modal_1 = __webpack_require__(1743);
var withResponsiveMode_1 = __webpack_require__(325);
var stylesImport = __webpack_require__(672);
var styles = stylesImport;
var DialogContent_1 = __webpack_require__(1563);
var Dialog = /** @class */ (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this._getSubTextId = function () {
            var _a = _this.props, ariaDescribedById = _a.ariaDescribedById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, subText = _a.subText;
            var id = ariaDescribedById || (modalProps && modalProps.subtitleAriaId);
            if (!id) {
                id = (subText || (dialogContentProps && dialogContentProps.subText)) && _this._defaultSubTextId;
            }
            return id;
        };
        _this._getTitleTextId = function () {
            var _a = _this.props, ariaLabelledById = _a.ariaLabelledById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, title = _a.title;
            var id = ariaLabelledById || (modalProps && modalProps.titleAriaId);
            if (!id) {
                id = (title || (dialogContentProps && dialogContentProps.title)) && _this._defaultTitleTextId;
            }
            return id;
        };
        _this._id = Utilities_1.getId('Dialog');
        _this._defaultTitleTextId = _this._id + '-title';
        _this._defaultSubTextId = _this._id + '-subText';
        _this._warnDeprecations({
            'isOpen': 'hidden',
            'type': 'dialogContentProps.type',
            'subText': 'dialogContentProps.subText',
            'contentClassName': 'dialogContentProps.className',
            'topButtonsProps': 'dialogContentProps.topButtonsProps',
            'className': 'modalProps.className',
            'isDarkOverlay': 'modalProps.isDarkOverlay',
            'isBlocking': 'modalProps.isBlocking',
            'containerClassName': 'modalProps.containerClassName',
            'onDismissed': 'modalProps.onDismissed',
            'onLayerDidMount': 'modalProps.onLayerDidMount',
            'ariaDescribedById': 'modalProps.subtitleAriaId',
            'ariaLabelledById': 'modalProps.titleAriaId'
        });
        return _this;
    }
    Dialog.prototype.render = function () {
        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, isOpen = _a.isOpen, className = _a.className, onDismiss = _a.onDismiss, onDismissed = _a.onDismissed, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, subText = _a.subText, title = _a.title, type = _a.type, contentClassName = _a.contentClassName, topButtonsProps = _a.topButtonsProps, dialogContentProps = _a.dialogContentProps, modalProps = _a.modalProps, containerClassName = _a.containerClassName, hidden = _a.hidden;
        return (React.createElement(Modal_1.Modal, tslib_1.__assign({ elementToFocusOnDismiss: elementToFocusOnDismiss, firstFocusableSelector: firstFocusableSelector, forceFocusInsideTrap: forceFocusInsideTrap, ignoreExternalFocusing: ignoreExternalFocusing, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap, onDismissed: onDismissed, onLayerDidMount: onLayerDidMount, responsiveMode: responsiveMode }, modalProps, { isDarkOverlay: isDarkOverlay !== undefined ? isDarkOverlay : modalProps.isDarkOverlay, isBlocking: isBlocking !== undefined ? isBlocking : modalProps.isBlocking, isOpen: isOpen !== undefined ? isOpen : !hidden, className: Utilities_1.css('ms-Dialog', className ? className : modalProps.className), containerClassName: Utilities_1.css(styles.main, containerClassName ? containerClassName : modalProps.containerClassName), onDismiss: onDismiss ? onDismiss : modalProps.onDismiss, subtitleAriaId: this._getSubTextId(), titleAriaId: this._getTitleTextId() }),
            React.createElement(DialogContent_1.DialogContent, tslib_1.__assign({ titleId: this._defaultTitleTextId, subTextId: this._defaultSubTextId, title: title, subText: subText, showCloseButton: isBlocking !== undefined ? !isBlocking : !modalProps.isBlocking, topButtonsProps: topButtonsProps ? topButtonsProps : dialogContentProps.topButtonsProps, type: type !== undefined ? type : dialogContentProps.type, onDismiss: onDismiss ? onDismiss : dialogContentProps.onDismiss, className: Utilities_1.css(contentClassName ? contentClassName : dialogContentProps.className) }, dialogContentProps), this.props.children)));
    };
    Dialog.defaultProps = {
        modalProps: {
            isDarkOverlay: true,
            isBlocking: false,
            className: '',
            containerClassName: ''
        },
        dialogContentProps: {
            type: DialogContent_types_1.DialogType.normal,
            className: '',
            topButtonsProps: [],
        },
        hidden: true,
    };
    Dialog = tslib_1.__decorate([
        withResponsiveMode_1.withResponsiveMode
    ], Dialog);
    return Dialog;
}(Utilities_1.BaseComponent));
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map

/***/ }),

/***/ 1752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1753), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Label_1 = __webpack_require__(1559);
var Icon_1 = __webpack_require__(43);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(1754);
var styles = stylesImport;
var Styling_1 = __webpack_require__(21);
var TextField = /** @class */ (function (_super) {
    tslib_1.__extends(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({
            'iconClass': 'iconProps',
            'addonString': 'prefix',
            'onRenderAddon': 'onRenderPrefix'
        });
        _this._warnMutuallyExclusive({
            'value': 'defaultValue'
        });
        _this._id = Utilities_1.getId('TextField');
        _this._descriptionId = Utilities_1.getId('TextFieldDescription');
        _this.state = {
            value: props.value || props.defaultValue || '',
            isFocused: false,
            errorMessage: ''
        };
        _this._onInputChange = _this._onInputChange.bind(_this);
        _this._onFocus = _this._onFocus.bind(_this);
        _this._onBlur = _this._onBlur.bind(_this);
        _this._delayedValidate = _this._async.debounce(_this._validate, _this.props.deferredValidationTime);
        _this._lastValidation = 0;
        _this._isDescriptionAvailable = false;
        return _this;
    }
    Object.defineProperty(TextField.prototype, "value", {
        /**
         * Gets the current value of the text field.
         */
        get: function () {
            return this.state.value;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype.componentDidMount = function () {
        this._isMounted = true;
        this._adjustInputHeight();
        if (this.props.validateOnLoad) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype.componentWillReceiveProps = function (newProps) {
        var onBeforeChange = this.props.onBeforeChange;
        if (newProps.value !== undefined && newProps.value !== this.state.value) {
            if (onBeforeChange) {
                onBeforeChange(newProps.value);
            }
            this._latestValue = newProps.value;
            this.setState({
                value: newProps.value,
                errorMessage: ''
            });
            this._delayedValidate(newProps.value);
        }
    };
    TextField.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    TextField.prototype.render = function () {
        var _a = this.props, className = _a.className, description = _a.description, disabled = _a.disabled, iconClass = _a.iconClass, iconProps = _a.iconProps, multiline = _a.multiline, required = _a.required, underlined = _a.underlined, borderless = _a.borderless, addonString = _a.addonString, // @deprecated
        prefix = _a.prefix, suffix = _a.suffix, _b = _a.onRenderAddon, onRenderAddon = _b === void 0 ? this._onRenderAddon : _b, // @deprecated
        _c = _a.onRenderPrefix, // @deprecated
        onRenderPrefix = _c === void 0 ? this._onRenderPrefix : _c, _d = _a.onRenderSuffix, onRenderSuffix = _d === void 0 ? this._onRenderSuffix : _d, _e = _a.onRenderLabel, onRenderLabel = _e === void 0 ? this._onRenderLabel : _e;
        var isFocused = this.state.isFocused;
        var errorMessage = this._errorMessage;
        this._isDescriptionAvailable = Boolean(description || errorMessage);
        var renderProps = tslib_1.__assign({}, this.props, { componentId: this._id });
        var textFieldClassName = Utilities_1.css('ms-TextField', styles.root, className, (_f = {},
            _f['is-required ' + styles.rootIsRequiredLabel] = this.props.label && required,
            _f['is-required ' + styles.rootIsRequiredPlaceholderOnly] = !this.props.label && required,
            _f['is-disabled ' + styles.rootIsDisabled] = disabled,
            _f['is-active ' + styles.rootIsActive] = isFocused,
            _f['ms-TextField--multiline ' + styles.rootIsMultiline] = multiline,
            _f['ms-TextField--underlined ' + styles.rootIsUnderlined] = underlined,
            _f['ms-TextField--borderless ' + styles.rootIsBorderless] = borderless,
            _f));
        return (React.createElement("div", { className: textFieldClassName },
            React.createElement("div", { className: Utilities_1.css('ms-TextField-wrapper', styles.wrapper, underlined ? errorMessage && styles.invalid : '') },
                onRenderLabel(renderProps, this._onRenderLabel),
                React.createElement("div", { className: Utilities_1.css('ms-TextField-fieldGroup', styles.fieldGroup, isFocused && styles.fieldGroupIsFocused, errorMessage && styles.invalid) },
                    (addonString !== undefined || this.props.onRenderAddon) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-prefix', styles.fieldPrefixSuffix) }, onRenderAddon(this.props, this._onRenderAddon))),
                    (prefix !== undefined || this.props.onRenderPrefix) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-prefix', styles.fieldPrefixSuffix) }, onRenderPrefix(this.props, this._onRenderPrefix))),
                    multiline ? this._renderTextArea() : this._renderInput(),
                    (iconClass || iconProps) && React.createElement(Icon_1.Icon, tslib_1.__assign({ className: Utilities_1.css(iconClass, styles.icon) }, iconProps)),
                    (suffix !== undefined || this.props.onRenderSuffix) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-suffix', styles.fieldPrefixSuffix) }, onRenderSuffix(this.props, this._onRenderSuffix))))),
            this._isDescriptionAvailable &&
                React.createElement("span", { id: this._descriptionId },
                    description && React.createElement("span", { className: Utilities_1.css('ms-TextField-description', styles.description) }, description),
                    errorMessage &&
                        React.createElement("div", null,
                            React.createElement(Utilities_1.DelayedRender, null,
                                React.createElement("p", { className: Utilities_1.css('ms-TextField-errorMessage', Styling_1.AnimationClassNames.slideDownIn20, styles.errorMessage) },
                                    React.createElement("span", { "aria-live": 'assertive', className: styles.errorText, "data-automation-id": 'error-message' }, errorMessage)))))));
        var _f;
    };
    /**
     * Sets focus on the text field
     */
    TextField.prototype.focus = function () {
        if (this._textElement) {
            this._textElement.focus();
        }
    };
    /**
     * Selects the text field
     */
    TextField.prototype.select = function () {
        if (this._textElement) {
            this._textElement.select();
        }
    };
    /**
     * Sets the selection start of the text field to a specified value
     */
    TextField.prototype.setSelectionStart = function (value) {
        if (this._textElement) {
            this._textElement.selectionStart = value;
        }
    };
    /**
     * Sets the selection end of the text field to a specified value
     */
    TextField.prototype.setSelectionEnd = function (value) {
        if (this._textElement) {
            this._textElement.selectionEnd = value;
        }
    };
    Object.defineProperty(TextField.prototype, "selectionStart", {
        /**
         * Gets the selection start of the text field
         */
        get: function () {
            return this._textElement ? this._textElement.selectionStart : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextField.prototype, "selectionEnd", {
        /**
         * Gets the selection end of the text field
         */
        get: function () {
            return this._textElement ? this._textElement.selectionEnd : -1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the start and end positions of a selection in a text field.
     * @param start Index of the start of the selection.
     * @param end Index of the end of the selection.
     */
    TextField.prototype.setSelectionRange = function (start, end) {
        if (this._textElement) {
            this._textElement.setSelectionRange(start, end);
        }
    };
    TextField.prototype._onFocus = function (ev) {
        if (this.props.onFocus) {
            this.props.onFocus(ev);
        }
        this.setState({ isFocused: true });
        if (this.props.validateOnFocusIn) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype._onBlur = function (ev) {
        if (this.props.onBlur) {
            this.props.onBlur(ev);
        }
        this.setState({ isFocused: false });
        if (this.props.validateOnFocusOut) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype._onRenderLabel = function (props) {
        var label = props.label, componentId = props.componentId;
        if (label) {
            return (React.createElement(Label_1.Label, { htmlFor: componentId }, label));
        }
        return null;
    };
    // @deprecated
    TextField.prototype._onRenderAddon = function (props) {
        var addonString = props.addonString;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, addonString));
    };
    TextField.prototype._onRenderPrefix = function (props) {
        var prefix = props.prefix;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, prefix));
    };
    TextField.prototype._onRenderSuffix = function (props) {
        var suffix = props.suffix;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, suffix));
    };
    TextField.prototype._getTextElementClassName = function () {
        var textFieldClassName;
        if (this.props.multiline && !this.props.resizable) {
            textFieldClassName = Utilities_1.css('ms-TextField-field ms-TextField-field--unresizable', styles.field, styles.fieldIsUnresizable);
        }
        else {
            textFieldClassName = Utilities_1.css('ms-TextField-field', styles.field);
        }
        return Utilities_1.css(textFieldClassName, this.props.inputClassName, (_a = {},
            _a[styles.hasIcon] = !!this.props.iconClass,
            _a));
        var _a;
    };
    Object.defineProperty(TextField.prototype, "_errorMessage", {
        get: function () {
            var errorMessage = this.state.errorMessage;
            if (!errorMessage) {
                errorMessage = this.props.errorMessage;
            }
            return errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype._renderTextArea = function () {
        var textAreaProps = Utilities_1.getNativeProps(this.props, Utilities_1.textAreaProperties, ['defaultValue']);
        return (React.createElement("textarea", tslib_1.__assign({ id: this._id }, textAreaProps, { ref: this._resolveRef('_textElement'), value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._getTextElementClassName(), "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : null, "aria-invalid": !!this.state.errorMessage, "aria-label": this.props.ariaLabel, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextField.prototype._renderInput = function () {
        var inputProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['defaultValue']);
        return (React.createElement("input", tslib_1.__assign({ type: 'text', id: this._id }, inputProps, { ref: this._resolveRef('_textElement'), value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._getTextElementClassName(), "aria-label": this.props.ariaLabel, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : null, "aria-invalid": !!this.state.errorMessage, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextField.prototype._onInputChange = function (event) {
        var _this = this;
        var element = event.target;
        var value = element.value;
        // Avoid doing unnecessary work when the value has not changed.
        if (value === this._latestValue) {
            return;
        }
        this._latestValue = value;
        this.setState({
            value: value,
            errorMessage: ''
        }, function () {
            _this._adjustInputHeight();
            if (_this.props.onChanged) {
                _this.props.onChanged(value);
            }
        });
        var _a = this.props, validateOnFocusIn = _a.validateOnFocusIn, validateOnFocusOut = _a.validateOnFocusOut;
        if (!(validateOnFocusIn || validateOnFocusOut)) {
            this._delayedValidate(value);
        }
        var onBeforeChange = this.props.onBeforeChange;
        onBeforeChange(value);
    };
    TextField.prototype._validate = function (value) {
        var _this = this;
        // In case of _validate called multi-times during executing validate logic with promise return.
        if (this._latestValidateValue === value) {
            return;
        }
        this._latestValidateValue = value;
        var onGetErrorMessage = this.props.onGetErrorMessage;
        var result = onGetErrorMessage(value || '');
        if (result !== undefined) {
            if (typeof result === 'string') {
                this.setState({
                    errorMessage: result
                });
                this._notifyAfterValidate(value, result);
            }
            else {
                var currentValidation_1 = ++this._lastValidation;
                result.then(function (errorMessage) {
                    if (_this._isMounted && currentValidation_1 === _this._lastValidation) {
                        _this.setState({ errorMessage: errorMessage });
                    }
                    _this._notifyAfterValidate(value, errorMessage);
                });
            }
        }
        else {
            this._notifyAfterValidate(value, '');
        }
    };
    TextField.prototype._notifyAfterValidate = function (value, errorMessage) {
        if (this._isMounted &&
            value === this.state.value &&
            this.props.onNotifyValidationResult) {
            this.props.onNotifyValidationResult(errorMessage, value);
        }
    };
    TextField.prototype._adjustInputHeight = function () {
        if (this._textElement && this.props.autoAdjustHeight && this.props.multiline) {
            var textField = this._textElement;
            textField.style.height = '';
            var scrollHeight = textField.scrollHeight + 2; // +2 to avoid vertical scroll bars
            textField.style.height = scrollHeight + 'px';
        }
    };
    TextField.defaultProps = {
        multiline: false,
        resizable: true,
        autoAdjustHeight: false,
        underlined: false,
        borderless: false,
        onChanged: function () { },
        onBeforeChange: function () { },
        onNotifyValidationResult: function () { },
        onGetErrorMessage: function () { return undefined; },
        deferredValidationTime: 200,
        errorMessage: '',
        validateOnFocusIn: false,
        validateOnFocusOut: false,
        validateOnLoad: true,
    };
    return TextField;
}(Utilities_1.BaseComponent));
exports.TextField = TextField;
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 1754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;position:relative}.screenReaderOnly_5c753ca1{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.fieldGroup_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;border:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";background:" }, { "theme": "bodyBackground", "defaultValue": "#ffffff" }, { "rawString": ";height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;position:relative}.fieldGroup_5c753ca1:hover{border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}.fieldGroup_5c753ca1.fieldGroupIsFocused_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}.rootIsDisabled_5c753ca1 .fieldGroup_5c753ca1{background-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";border-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}@media screen and (-ms-high-contrast: active){.fieldGroup_5c753ca1:hover,.fieldGroup_5c753ca1.fieldGroupIsFocused_5c753ca1{border-color:Highlight}}.fieldGroup_5c753ca1::-ms-clear{display:none}.root_5c753ca1.rootIsDisabled_5c753ca1 .field{background-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";border-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}.fieldPrefixSuffix_5c753ca1{background:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 10px;line-height:1}.field_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;font-size:14px;border-radius:0;border:none;background:none;color:" }, { "theme": "bodyText", "defaultValue": "#333333" }, { "rawString": ";padding:0 12px 0 12px;width:100%;text-overflow:ellipsis;outline:0}[dir='rtl'] .field_5c753ca1{padding:0 12px 0 12px}.field_5c753ca1:active,.field_5c753ca1:focus,.field_5c753ca1:hover{outline:0}[dir='ltr'] .field_5c753ca1.hasIcon_5c753ca1{padding-right:24px}[dir='rtl'] .field_5c753ca1.hasIcon_5c753ca1{padding-left:24px}.field_5c753ca1[disabled]{background-color:transparent;border-color:transparent;pointer-events:none;cursor:default}.field_5c753ca1 .field_5c753ca1::-webkit-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1:-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1::-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field::-webkit-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field:-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field::-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1::placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsRequiredLabel_5c753ca1 .ms-Label::after{content:' *';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{content:'*';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": ";position:absolute;top:-5px}[dir='ltr'] .root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{right:-10px}[dir='rtl'] .root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{left:-10px}.root_5c753ca1.rootIsActive_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}.icon_5c753ca1{pointer-events:none;position:absolute;bottom:5px;top:auto;font-size:16px;line-height:18px}html[dir='ltr'] .icon_5c753ca1{right:8px}html[dir='rtl'] .icon_5c753ca1{left:8px}.description_5c753ca1{color:" }, { "theme": "bodySubtext", "defaultValue": "#666666" }, { "rawString": ";font-size:11px}.rootIsBorderless_5c753ca1 .fieldGroup_5c753ca1{border-color:transparent;border-width:0}.root_5c753ca1.rootIsUnderlined_5c753ca1{border-width:0px}.root_5c753ca1.rootIsUnderlined_5c753ca1:hover:not(.rootIsDisabled_5c753ca1){border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_5c753ca1.rootIsUnderlined_5c753ca1:hover:not(.rootIsDisabled_5c753ca1){border-color:Highlight}}.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1{display:-webkit-box;display:-ms-flexbox;display:flex;border-bottom:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";width:100%}.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1,.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1:focus,.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1:hover{border-bottom:1px solid " }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{font-size:14px;line-height:22px;height:32px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{margin-right:8px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{margin-left:8px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:12px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:12px}.root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0px;border-width:0}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{text-align:left}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{text-align:right}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1{border-bottom-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .ms-Label{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .field_5c753ca1{background-color:transparent;color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .fieldGroup_5c753ca1{background-color:transparent}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsActive_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsActive_5c753ca1{border-color:Highlight}}.root_5c753ca1.rootIsMultiline_5c753ca1 .fieldGroup_5c753ca1{min-height:60px;height:auto;display:-webkit-box;display:-ms-flexbox;display:flex}.root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1{line-height:17px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding-top:6px;overflow:auto;width:100%}[dir='ltr'] .root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.hasIcon_5c753ca1{padding-right:40px}[dir='rtl'] .root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.hasIcon_5c753ca1{padding-left:40px}.errorMessage_5c753ca1{font-size:12px;font-weight:400;color:" }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": ";margin:0;padding-top:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.invalid_5c753ca1,.invalid_5c753ca1:focus,.invalid_5c753ca1:hover{border-color:" }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": "}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:12px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:12px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:0}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:0}html[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .field_5c753ca1{text-align:left}html[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .field_5c753ca1{text-align:right}.root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-bottom:8px;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}[dir='ltr'] .root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-right:24px}[dir='rtl'] .root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-left:24px}.root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.fieldIsUnresizable_5c753ca1{resize:none}.hidden_5c753ca1{display:none}\n" }]);
exports.root = "root_5c753ca1";
exports.screenReaderOnly = "screenReaderOnly_5c753ca1";
exports.fieldGroup = "fieldGroup_5c753ca1";
exports.fieldGroupIsFocused = "fieldGroupIsFocused_5c753ca1";
exports.rootIsDisabled = "rootIsDisabled_5c753ca1";
exports.fieldPrefixSuffix = "fieldPrefixSuffix_5c753ca1";
exports.field = "field_5c753ca1";
exports.hasIcon = "hasIcon_5c753ca1";
exports.rootIsRequiredLabel = "rootIsRequiredLabel_5c753ca1";
exports.rootIsRequiredPlaceholderOnly = "rootIsRequiredPlaceholderOnly_5c753ca1";
exports.rootIsActive = "rootIsActive_5c753ca1";
exports.icon = "icon_5c753ca1";
exports.description = "description_5c753ca1";
exports.rootIsBorderless = "rootIsBorderless_5c753ca1";
exports.rootIsUnderlined = "rootIsUnderlined_5c753ca1";
exports.wrapper = "wrapper_5c753ca1";
exports.invalid = "invalid_5c753ca1";
exports.rootIsMultiline = "rootIsMultiline_5c753ca1";
exports.errorMessage = "errorMessage_5c753ca1";
exports.fieldIsUnresizable = "fieldIsUnresizable_5c753ca1";
exports.hidden = "hidden_5c753ca1";
//# sourceMappingURL=TextField.scss.js.map

/***/ }),

/***/ 1777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var config = {};
function initializePersona(inputConfig) {
    config = inputConfig;
}
exports.initializePersona = initializePersona;
function getConfig() {
    return config;
}
exports.getConfig = getConfig;
//# sourceMappingURL=personaConfig.js.map

/***/ }),

/***/ 2081:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FiltersContextMenu_1 = __webpack_require__(4831);
exports.FiltersContextMenu = FiltersContextMenu_1.default;
var PersonaPill_1 = __webpack_require__(4834);
exports.PersonaPill = PersonaPill_1.default;
var PersonaPillWell_1 = __webpack_require__(4837);
exports.PersonaPillWell = PersonaPillWell_1.default;
var SuggestionsContextMenu_1 = __webpack_require__(4838);
exports.SuggestionsContextMenu = SuggestionsContextMenu_1.default;
var SearchInContextFeedbackDialog_1 = __webpack_require__(4841);
exports.SearchInContextFeedbackDialog = SearchInContextFeedbackDialog_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2124), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(2125);
var styles = stylesImport;
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, children = _a.children, className = _a.className, href = _a.href;
        return (href ? (React.createElement("a", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.anchorProperties), { className: Utilities_1.css('ms-Link', styles.root, className, disabled && ('is-disabled ' + styles.isDisabled), !disabled && styles.isEnabled), onClick: this._onClick, ref: this._resolveRef('_link'), target: this.props.target, "aria-disabled": disabled }), children)) : (React.createElement("button", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.buttonProperties), { className: Utilities_1.css('ms-Link', styles.root, className, disabled && ('is-disabled ' + styles.isDisabled), !disabled && styles.isEnabled), onClick: this._onClick, ref: this._resolveRef('_link'), "aria-disabled": disabled }), children)));
    };
    Link.prototype.focus = function () {
        if (this._link) {
            this._link.focus();
        }
    };
    Link.prototype._onClick = function (ev) {
        var onClick = this.props.onClick;
        if (onClick) {
            onClick(ev);
        }
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Link.prototype, "_onClick", null);
    return Link;
}(Utilities_1.BaseComponent));
exports.Link = Link;
//# sourceMappingURL=Link.js.map

/***/ }),

/***/ 2125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_6f11bd51{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";margin:0;overflow:inherit;padding:0;text-overflow:inherit}.isEnabled_6f11bd51:active,.isEnabled_6f11bd51:hover{color:" }, { "theme": "themeDarker", "defaultValue": "#004578" }, { "rawString": "}.isEnabled_6f11bd51:focus{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.isDisabled_6f11bd51{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";pointer-events:none;cursor:default}button.root_6f11bd51{background:none;border:none;cursor:pointer;display:inline;font-size:inherit}button.root_6f11bd51::-moz-focus-inner{border:0}button.root_6f11bd51{outline:transparent}button.root_6f11bd51{position:relative}.ms-Fabric.is-focusVisible button.root_6f11bd51:focus:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid " }, { "theme": "focusBorder", "defaultValue": "#000000" }, { "rawString": "}html[dir='ltr'] button.root_6f11bd51{text-align:left}html[dir='rtl'] button.root_6f11bd51{text-align:right}@media screen and (-ms-high-contrast: active){button.root_6f11bd51{color:Highlight}}a.root_6f11bd51{text-decoration:none}.ms-Fabric.is-focusVisible a.root_6f11bd51:focus{outline:1px solid " }, { "theme": "focusBorder", "defaultValue": "#000000" }, { "rawString": "}\n" }]);
exports.root = "root_6f11bd51";
exports.isEnabled = "isEnabled_6f11bd51";
exports.isDisabled = "isDisabled_6f11bd51";
//# sourceMappingURL=Link.scss.js.map

/***/ }),

/***/ 2612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_guid_1 = __webpack_require__(585);
exports.isInitialized = false;
exports.clientCorrelationId = undefined;
exports.clientType = undefined;
exports.clientScenario = undefined;
exports.culture = undefined;
exports.isConsumer = false;
exports.useDogfood = false;
exports.isMicrosoftUser = false;
var logger = undefined;
var MicrosoftTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47';
var MicrosoftExoTenantId = '626bd560-f1d8-4cf1-a7fa-91aae03cc409';
function initializeLoki(config) {
    if (exports.isInitialized) {
        throw new Error('initializeLoki can be called only once!');
    }
    if (!config) {
        throw new Error('Loki config object is mandatory!');
    }
    exports.clientType = 'OwaMail';
    exports.clientScenario = config.isConsumer ? 'OwaConsumer' : 'OwaEnterprise';
    exports.culture = config.culture;
    exports.isConsumer = config.isConsumer;
    exports.useDogfood = config.useDogfood;
    logger = config.logger;
    var tenantId = config.tenantId && config.tenantId.toLowerCase();
    exports.isMicrosoftUser = tenantId === MicrosoftTenantId || tenantId === MicrosoftExoTenantId;
    exports.clientCorrelationId = config.clientCorrelationId || owa_guid_1.getGuid();
    exports.isInitialized = true;
}
exports.initializeLoki = initializeLoki;
function log(logType, logResultType, message) {
    logger(logType, [logResultType, message]);
}
exports.log = log;
//# sourceMappingURL=lokiContext.js.map

/***/ }),

/***/ 2622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isLokiEndpoint_1 = __webpack_require__(2716);
exports.isLokiEndpoint = isLokiEndpoint_1.isLokiEndpoint;
var Base64 = __webpack_require__(2717);
exports.Base64 = Base64;
var Functional = __webpack_require__(2718);
exports.Functional = Functional;
var StorageUtils = __webpack_require__(2719);
exports.StorageUtils = StorageUtils;
var StringUtils = __webpack_require__(2648);
exports.StringUtils = StringUtils;
var UrlUtils_1 = __webpack_require__(2722);
exports.getUrlParameter = UrlUtils_1.getUrlParameter;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isNullOrWhiteSpace_1 = __webpack_require__(2676);
exports.isNullOrWhiteSpace = isNullOrWhiteSpace_1.isNullOrWhiteSpace;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2682), exports);
//# sourceMappingURL=Checkbox.js.map

/***/ }),

/***/ 2640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = __webpack_require__(21);
var Utilities_1 = __webpack_require__(7);
var MS_CHECKBOX_LABEL_SIZE = '20px';
var MS_CHECKBOX_TRANSITION_DURATION = '200ms';
var MS_CHECKBOX_TRANSITION_TIMING = 'cubic-bezier(.4, 0, .23, 1)';
exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var checkmarkFontColor = semanticColors.inputForegroundChecked;
    var checkmarkFontColorCheckedDisabled = semanticColors.disabledBackground;
    var checkboxBorderColor = semanticColors.inputBorderHovered;
    var checkboxBorderColorChecked = semanticColors.inputBackgroundChecked;
    var checkboxBorderColorDisabled = semanticColors.disabledText;
    var checkboxBorderHoveredColor = semanticColors.inputBorderHovered;
    var checkboxBackgroundChecked = semanticColors.inputBackgroundChecked;
    var checkboxBackgroundCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
    var checkboxBorderColorCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
    var checkboxBackgroundDisabled = semanticColors.disabledText;
    var checkboxTextColor = semanticColors.bodyText;
    var checkboxTextColorDisabled = semanticColors.disabledText;
    var styles = {
        root: [
            Styling_1.getFocusStyle(theme, -2),
            {
                padding: '0',
                border: 'none',
                background: 'none',
                margin: '0',
                outline: 'none',
                display: 'block',
                cursor: 'pointer',
            }
        ],
        label: {
            display: 'inline-flex',
            margin: '0 -4px',
            alignItems: 'center',
            cursor: 'pointer',
            position: 'relative',
            userSelect: 'none',
            textAlign: 'left'
        },
        labelReversed: {
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end'
        },
        labelDisabled: {
            cursor: 'default'
        },
        checkbox: {
            display: 'flex',
            flexShrink: 0,
            alignItems: 'center',
            justifyContent: 'center',
            height: MS_CHECKBOX_LABEL_SIZE,
            width: MS_CHECKBOX_LABEL_SIZE,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: checkboxBorderColor,
            margin: '0 4px',
            boxSizing: 'border-box',
            transitionProperty: 'background, border, border-color',
            transitionDuration: MS_CHECKBOX_TRANSITION_DURATION,
            transitionTimingFunction: MS_CHECKBOX_TRANSITION_TIMING,
            /* incase the icon is bigger than the box */
            overflow: 'hidden'
        },
        checkboxHovered: {
            borderColor: checkboxBorderHoveredColor,
        },
        checkboxFocused: {
            borderColor: checkboxBorderHoveredColor,
        },
        checkboxChecked: {
            background: checkboxBackgroundChecked,
            borderColor: checkboxBorderColorChecked
        },
        checkboxCheckedHovered: {
            background: checkboxBackgroundCheckedHovered,
            borderColor: checkboxBorderColorCheckedHovered
        },
        checkboxCheckedFocused: {
            background: checkboxBackgroundCheckedHovered,
            borderColor: checkboxBorderColorCheckedHovered
        },
        checkboxDisabled: {
            background: checkboxBackgroundDisabled,
            borderColor: checkboxBorderColorDisabled
        },
        checkboxCheckedDisabled: {
            background: checkboxBackgroundDisabled,
            borderColor: checkboxBorderColorDisabled
        },
        checkmark: {
            opacity: '0',
            color: checkmarkFontColor
        },
        checkmarkChecked: {
            opacity: '1'
        },
        checkmarkDisabled: {},
        checkmarkCheckedDisabled: {
            opacity: '1',
            color: checkmarkFontColorCheckedDisabled,
        },
        text: {
            color: checkboxTextColor,
            margin: '0 4px',
            fontSize: Styling_1.FontSizes.medium
        },
        textHovered: {
            color: palette.black,
        },
        textFocused: {
            color: palette.black,
        },
        textDisabled: {
            color: checkboxTextColorDisabled,
        }
    };
    return Styling_1.concatStyleSets(styles, customStyles);
});
//# sourceMappingURL=Checkbox.styles.js.map

/***/ }),

/***/ 2644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLokiBootstrapperConfig_1 = __webpack_require__(2645);
exports.getLokiBootstrapperConfig = getLokiBootstrapperConfig_1.getLokiBootstrapperConfig;
var userInfoProvider_1 = __webpack_require__(2725);
exports.getUserInfo = userInfoProvider_1.getUserInfo;
var lokiContext_1 = __webpack_require__(2612);
exports.lokiClientCorrelationId = lokiContext_1.clientCorrelationId;
exports.initializeLoki = lokiContext_1.initializeLoki;
var live_persona_card_bootstrapper_1 = __webpack_require__(2650);
exports.initializeLivePersonaCard = live_persona_card_bootstrapper_1.initializeLivePersonaCard;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var requestAuthTokenHandler_1 = __webpack_require__(2646);
var lokiContext = __webpack_require__(2612);
function getLokiBootstrapperConfig() {
    if (!lokiContext.isInitialized) {
        throw new Error('You must call initializeLoki!');
    }
    var config = {
        culture: lokiContext.culture,
        region: getLokiRegion(lokiContext.useDogfood, lokiContext.isMicrosoftUser),
        clientType: lokiContext.clientType,
        clientContextType: lokiContext.clientScenario,
        clientCorrelationId: lokiContext.clientCorrelationId,
        logMessage: function (logType, logResultType, message) {
            lokiContext.log(logType, logResultType, message);
        },
        getAuthToken: requestAuthTokenHandler_1.refreshAuthToken,
        authToken: requestAuthTokenHandler_1.latestAuthToken,
    };
    return config;
}
exports.getLokiBootstrapperConfig = getLokiBootstrapperConfig;
function getLokiRegion(useLokiDogfood, isMicrosoftUser) {
    if (useLokiDogfood) {
        return 'df';
    }
    if (isMicrosoftUser) {
        return 'msit';
    }
    return '';
}
//# sourceMappingURL=getLokiBootstrapperConfig.js.map

/***/ }),

/***/ 2646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var loki_auth_token_1 = __webpack_require__(2715);
var lokiContext_1 = __webpack_require__(2612);
var getLokiAuthTokenAsync_1 = __webpack_require__(2724);
var authTokenProvider = undefined;
exports.latestAuthToken = undefined;
function getAuthToken() {
    if (!authTokenProvider) {
        authTokenProvider = new loki_auth_token_1.AuthTokenProvider(function () { return lokiContext_1.clientCorrelationId; }, getRefreshAuthToken(), null, null);
    }
    return authTokenProvider.getAuthToken();
}
exports.getAuthToken = getAuthToken;
function refreshAuthToken(onSuccess, onFailure) {
    getLokiAuthTokenAsync_1.default().then(function (token) {
        var authTokenRequestCorrelationId = lokiContext_1.clientCorrelationId;
        if (token) {
            setAuthToken(token);
            onSuccess(token, authTokenRequestCorrelationId);
        }
        else {
            onFailure('Failed to get auth token from Loki', authTokenRequestCorrelationId);
        }
    });
}
exports.refreshAuthToken = refreshAuthToken;
function setAuthToken(newAuthToken) {
    exports.latestAuthToken = newAuthToken;
    loki_auth_token_1.setAuthToken(lokiContext_1.clientCorrelationId, newAuthToken);
}
function getRefreshAuthToken() {
    return function (callback) {
        refreshAuthToken(function (authToken, authRequestCorrelationId) {
            callback(authToken, '', authRequestCorrelationId);
        }, function (errorMessage, authRequestCorrelationId) {
            callback('', errorMessage, authRequestCorrelationId);
        });
    };
}
//# sourceMappingURL=requestAuthTokenHandler.js.map

/***/ }),

/***/ 2647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lpc_utils_1 = __webpack_require__(2622);
var lpc_utils_2 = __webpack_require__(2622);
var AUTH_TOKEN_PARSE_ERROR = "AuthTokenParseError";
var DEFAULT_GET_AUTH_TOKEN_TIMEOUT = 10000; /* 10s */
var TOKEN_LIFETIME_BUFFER = 5 * 60 * 1000; /* 5m */
var GET_AUTH_TOKEN_TIMEOUT = "GetAuthTokenTimeout";
var CACHED_TOKEN_EXPIRED = "CachedTokenExpired";
var AUTH_TOKEN_PARTS = 3;
var INVALID_TOKEN_EXPIRATION = "InvalidTokenExpirationValue";
var AuthToken = (function () {
    function AuthToken(value, scopeName, logger) {
        this.value = value;
        this.scopeName = scopeName;
        this.logger = logger;
    }
    AuthToken.prototype.isValid = function () {
        if (!this.value) {
            return false;
        }
        var expiryTime = this.extractAuthTokenExpiration();
        if (expiryTime <= 0) {
            if (this.logger) {
                this.logger.logError(INVALID_TOKEN_EXPIRATION, this.scopeName, { expiryTime: expiryTime.toString() });
            }
            return false;
        }
        // Date.now() returns milliseconds while expiryTime in authToken uses seconds
        if (Date.now() > expiryTime * 1000 - TOKEN_LIFETIME_BUFFER) {
            if (this.logger) {
                this.logger.logEvent(CACHED_TOKEN_EXPIRED, this.scopeName);
            }
            return false;
        }
        return true;
    };
    AuthToken.prototype.getValue = function () {
        return this.value;
    };
    AuthToken.prototype.refresh = function (refreshAuthTokenCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var timeoutId = window.setTimeout(function () {
                // Don't introduce PII as we are logging the rejection scenarios
                reject(GET_AUTH_TOKEN_TIMEOUT);
            }, DEFAULT_GET_AUTH_TOKEN_TIMEOUT);
            refreshAuthTokenCallback(function (token, error, authRequestCorrelationId) {
                window.clearTimeout(timeoutId);
                if (lpc_utils_1.StringUtils.isNullOrEmpty(error)) {
                    _this.value = token;
                    resolve(_this);
                }
                else {
                    // Don't introduce PII as we are logging the rejection scenarios
                    reject("Couldn't retrieve token! authRequestCorrelationId: " + authRequestCorrelationId);
                }
            });
        });
    };
    AuthToken.prototype.getLoggableProps = function () {
        // Expiry time is in seconds in the auth token, so convert to milliseconds:
        var expiryTime = this.extractAuthTokenExpiration() * 1000;
        return { expirationTime: expiryTime, expiresIn: expiryTime - Date.now() };
    };
    AuthToken.prototype.getLoggablePropsAsString = function () {
        return JSON.stringify(this.getLoggableProps());
    };
    AuthToken.prototype.getTokenLifetimeBuffer = function () {
        return TOKEN_LIFETIME_BUFFER;
    };
    // Extract the object id from the auth token
    AuthToken.prototype.extractAuthTokenOid = function () {
        /* tslint:disable:no-any */
        var payload = this.extractPayload();
        /* tslint:enable:no-any */
        if (payload) {
            return payload.oid;
        }
        return "";
    };
    AuthToken.prototype.extractAuthTokenExpiration = function () {
        /* tslint:disable:no-any */
        var payload = this.extractPayload();
        /* tslint:enable:no-any */
        if (payload) {
            return payload.exp;
        }
        return 0;
    };
    /* tslint:disable:no-any */
    AuthToken.prototype.extractPayload = function () {
        /* tslint:enable:no-any */
        if (!this.value) {
            return null;
        }
        var tokenParts = this.value.split(".");
        if (tokenParts.length !== AUTH_TOKEN_PARTS) {
            if (this.logger) {
                this.logger.logError(AUTH_TOKEN_PARSE_ERROR, this.scopeName, { partsCount: tokenParts.length.toString() });
            }
            return null;
        }
        try {
            /* tslint:disable:no-any */
            var payload = JSON.parse(lpc_utils_2.Base64.decode(tokenParts[1]));
            /* tslint:enable:no-any */
            return payload;
        }
        catch (ex) {
            if (this.logger) {
                this.logger.logError(AUTH_TOKEN_PARSE_ERROR, this.scopeName, { error: ex });
            }
            return null;
        }
    };
    return AuthToken;
}());
exports.AuthToken = AuthToken;
//# sourceMappingURL=authToken.js.map

/***/ }),

/***/ 2648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var emptyString = "";
var guidEmpty = "00000000-0000-0000-0000-000000000000";
var guidFormatString = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
function isNullOrEmpty(str) {
    return str === null || str === undefined || str === emptyString;
}
exports.isNullOrEmpty = isNullOrEmpty;
function isNullOrWhitespace(str) {
    return str === null || str === undefined || str.trim() === emptyString;
}
exports.isNullOrWhitespace = isNullOrWhitespace;
function isGuidNullOrEmpty(guid) {
    return isNullOrEmpty(guid) || guid === guidEmpty;
}
exports.isGuidNullOrEmpty = isGuidNullOrEmpty;
// Ranges from isCJK method found numerous places in msasg code.
// This one breaks on Android, and has therefore been replaced by the other one by this tool:
// https://mothereff.in/regexpu
// const cjkRegExp = /[\u{3400}-\u{9fff}\u{f900}-\u{faff}\u{20000}-\u{2a6df}\u{2f800}-\u{2fa1f}]/u;
var cjkRegExp = /(?:[\u3400-\u9FFF\uF900-\uFAFF]|[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]|\uD87E[\uDC00-\uDE1F])/;
function isCJK(text) {
    return cjkRegExp.test(text);
}
exports.isCJK = isCJK;
function generateGuid() {
    /* Equivalent of var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8); */
    return guidFormatString.replace(/[xy]/g, function (c) {
        var r;
        if (window.crypto) {
            var array = new Uint8Array(1);
            window.crypto.getRandomValues(array);
            r = array[0];
        }
        else {
            r = Math.floor(Math.random() * 16);
        }
        var v = c === "x" ? r % 16 : r % 4 + 8;
        return v.toString(16);
    });
}
exports.generateGuid = generateGuid;
/* Ex: { param1: val1, param2: val2 } => "param1=val1,param2=val2" */
function createCommaDelimitedParamStringFromObject(data) {
    // IE does not support data.constructor.name (https://stackoverflow.com/questions/25140723/constructor-name-is-undefined-in-internet-explorer)
    if (Object.prototype.toString.call(data) !== "[object Object]") {
        throw new TypeError("Param data must be a valid object");
    }
    var values = [];
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        values.push(key + "=" + data[key]);
    }
    return values.join(",");
}
exports.createCommaDelimitedParamStringFromObject = createCommaDelimitedParamStringFromObject;
function format(str) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!str) {
        return emptyString;
    }
    if (args != null && args.length > 0) {
        for (var i = 0; i < args.length; i++) {
            var val = args[i];
            var replString = val === null || val === undefined ? emptyString : val.toString();
            var matchPattern = new RegExp("\\{" + i + "\\}", "g");
            str = str.replace(matchPattern, replString);
        }
    }
    return str;
}
exports.format = format;
function toUTF8(s) {
    if (unescape && encodeURIComponent) {
        return unescape(encodeURIComponent(s));
    }
    else {
        return s;
    }
}
exports.toUTF8 = toUTF8;
function fromUTF8(s) {
    if (decodeURIComponent && escape) {
        return decodeURIComponent(escape(s));
    }
    else {
        return s;
    }
}
exports.fromUTF8 = fromUTF8;
//# sourceMappingURL=StringUtils.js.map

/***/ }),

/***/ 2649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lpc_utils_1 = __webpack_require__(2622);
var getItem = lpc_utils_1.StorageUtils.getItem, setItem = lpc_utils_1.StorageUtils.setItem, removeItem = lpc_utils_1.StorageUtils.removeItem;
var AUTH_TOKEN_STORAGE_KEY = "LokiAuthToken";
function setAuthTokenOnUrl(url, authToken) {
    if (authToken && lpc_utils_1.isLokiEndpoint(url)) {
        var queryStringOperator = url.indexOf("?") > -1 ? "&" : "?";
        return "" + url + queryStringOperator + "AuthToken=" + authToken;
    }
    return url;
}
exports.setAuthTokenOnUrl = setAuthTokenOnUrl;
function getAuthToken(appId) {
    return getItem(AUTH_TOKEN_STORAGE_KEY, appId || "") || "";
}
exports.getAuthToken = getAuthToken;
function setAuthToken(appId, authToken) {
    if (authToken) {
        setItem(AUTH_TOKEN_STORAGE_KEY, authToken, appId || "");
    }
}
exports.setAuthToken = setAuthToken;
function clearAuthToken(appId) {
    removeItem(AUTH_TOKEN_STORAGE_KEY, appId || "");
}
exports.clearAuthToken = clearAuthToken;
function removeAuthTokenFromUrl(url) {
    if (url) {
        return url.replace(/AuthToken=[\w-.]*[&$]?/, "");
    }
    return url;
}
exports.removeAuthTokenFromUrl = removeAuthTokenFromUrl;
//# sourceMappingURL=authUtils.js.map

/***/ }),

/***/ 2650:
/***/ (function(module, exports, __webpack_require__) {

/*! Version: 1.3.14; Third Party Notices: https://go.microsoft.com/fwlink/?linkid=855968 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("LivePersonaCardBootstrapper",[],e):"object"==typeof exports?exports.LivePersonaCardBootstrapper=e():t.LivePersonaCardBootstrapper=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=36)}([function(t,e,n){"use strict";n.d(e,"a",function(){return i});var i=function(){function t(t,e,n){this.type=t,this.message=e,this.rootCorrelationId=n}return t}()},function(t,e,n){"use strict";var i=function(){function t(t){this.low=0,this.high=0,this.low=parseInt(t,10),this.low<0&&(this.high=-1)}return t.prototype.Equals=function(e){var n=new t(e);return this.low===n.low&&this.high===n.high},t}();e.Int64=i;var r=function(){function t(t){this.low=0,this.high=0,this.low=parseInt(t,10)}return t.prototype.Equals=function(e){var n=new t(e);return this.low===n.low&&this.high===n.high},t}();e.UInt64=r;var o=function(){function t(){}return t.ToByte=function(t){return this.ToUInt8(t)},t.ToInt16=function(t){return 32767&t|(32768&t)<<16>>16},t.ToInt32=function(t){return 2147483647&t|2147483648&t},t.ToUInt8=function(t){return 255&t},t.ToUInt32=function(t){return 4294967295&t},t}();e.Number=o},function(t,e,n){"use strict";!function(t){t[t.NotSet=0]="NotSet",t[t.DistinguishedName=1]="DistinguishedName",t[t.GenericData=2]="GenericData",t[t.IPV4Address=3]="IPV4Address",t[t.IPv6Address=4]="IPv6Address",t[t.MailSubject=5]="MailSubject",t[t.PhoneNumber=6]="PhoneNumber",t[t.QueryString=7]="QueryString",t[t.SipAddress=8]="SipAddress",t[t.SmtpAddress=9]="SmtpAddress",t[t.Identity=10]="Identity",t[t.Uri=11]="Uri",t[t.Fqdn=12]="Fqdn",t[t.IPV4AddressLegacy=13]="IPV4AddressLegacy"}(e.AWTPiiKind||(e.AWTPiiKind={}))},function(t,e,n){"use strict";var i=n(12),r=n(2),o=n(4),s=function(){function t(){}return t.getPayloadBlob=function(t,e){var n=new i.IO.MemoryStream,r=new i.CompactBinaryProtocolWriter(n);return r.WriteFieldBegin(i.BondDataType.BT_MAP,3),r.WriteMapContainerBegin(e,i.BondDataType.BT_STRING,i.BondDataType.BT_LIST),Object.keys(t).forEach(function(e){r.WriteString(e);var n=t[e];r.WriteContainerBegin(1,i.BondDataType.BT_STRUCT),r.WriteFieldBegin(i.BondDataType.BT_STRING,2),r.WriteString("act_default_source"),r.WriteFieldBegin(i.BondDataType.BT_STRING,5),r.WriteString(o.newGuid()),r.WriteFieldBegin(i.BondDataType.BT_INT64,6),r.WriteInt64(o.numberToBondInt64(Date.now())),r.WriteFieldBegin(i.BondDataType.BT_LIST,8),r.WriteContainerBegin(n.length,i.BondDataType.BT_STRUCT);for(var s=0;s<n.length;++s)r.WriteBlob(n[s]);r.WriteStructEnd(!1)}),r.WriteStructEnd(!1),n.GetBuffer()},t.getEventBlob=function(t){var e=new i.IO.MemoryStream,n=new i.CompactBinaryProtocolWriter(e);n.WriteFieldBegin(i.BondDataType.BT_STRING,1),n.WriteString(t.id),n.WriteFieldBegin(i.BondDataType.BT_INT64,3),n.WriteInt64(o.numberToBondInt64(t.timestamp)),n.WriteFieldBegin(i.BondDataType.BT_STRING,5),n.WriteString(t.type),n.WriteFieldBegin(i.BondDataType.BT_STRING,6),n.WriteString(t.name);var s=[],u=[];return Object.keys(t.properties).forEach(function(e){t.properties[e].pii===r.AWTPiiKind.NotSet?s.push(e):u.push(e)}),s.length&&(n.WriteFieldBegin(i.BondDataType.BT_MAP,13),n.WriteMapContainerBegin(s.length,i.BondDataType.BT_STRING,i.BondDataType.BT_STRING),s.forEach(function(e){n.WriteString(e),n.WriteString(t.properties[e].value)})),u.length&&(n.WriteFieldBegin(i.BondDataType.BT_MAP,30),n.WriteMapContainerBegin(u.length,i.BondDataType.BT_STRING,i.BondDataType.BT_STRUCT),u.forEach(function(e){n.WriteString(e),n.WriteFieldBegin(i.BondDataType.BT_INT32,1),n.WriteInt32(1),n.WriteFieldBegin(i.BondDataType.BT_INT32,2),n.WriteInt32(t.properties[e].pii),n.WriteFieldBegin(i.BondDataType.BT_STRING,3),n.WriteString(t.properties[e].value),n.WriteStructEnd(!1)})),n.WriteStructEnd(!1),e.GetBuffer()},t.base64Encode=function(t){return i.Encoding.Base64.GetString(t)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=s},function(t,e,n){"use strict";function i(t){var e=new s.Int64("0");return e.low=4294967295&t,e.high=Math.floor(t/4294967296),e}function r(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(u,function(t){var e=16*Math.random()|0;return("x"===t?e:3&e|8).toString(16)})}function o(t){return!isNaN(t)&&null!==t&&t>=0&&t<=13}var s=n(1),u=/[xy]/g;e.numberToBondInt64=i,e.newGuid=r,e.isPii=o},function(t,e,n){"use strict";var i=n(2);e.AWTPiiKind=i.AWTPiiKind;var r=n(16);e.AWT=r.default,e.AWT_COLLECTOR_URL_UNITED_STATES="https://us.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_GERMANY="https://de.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_JAPAN="https://jp.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_AUSTRALIA="https://au.pipe.aria.microsoft.com/Collector/3.0/",e.AWT_COLLECTOR_URL_EUROPE="https://eu.pipe.aria.microsoft.com/Collector/3.0/"},function(t,e,n){"use strict";e.Version="1.2.0",e.FullVersionString="AWT-Web-CJS-"+e.Version},function(t,e,n){"use strict";function i(t){t=t.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");var e=new RegExp("[\\?&]"+t+"=([^&#]*)"),n=e.exec(location.search);return null===n?"":decodeURIComponent(n[1].replace(/\+/g," "))}e.a=i},function(t,e,n){"use strict";function i(t,e,i){return v=v||new Promise(function(r,a){try{var g,v,y=new p.a;o(t),n.i(h.a)(t).then(function(){return n.i(l.a)(t)}).then(function(e){return y.measureFromStart(p.b.getAuthToken),v=n.i(l.b)(e),t.tenantAadObjectId=v.tenantId,t.userAadObjectId=v.userAadId,t.userPuid=v.userPuid,n.i(c.a)(e,t)}).then(function(t){return y.measureFromStart(p.b.getLokiConfig),g=t,_.AWT.setContext("LokiUrl",t.LokiUrl),_.AWT.setContext("tenantAadObjectId",v.tenantId),_.AWT.setContext("userAadObjectId",v.userAadId),_.AWT.setContext("userPuid",v.userPuid),n.i(d.a)(g)}).then(function(){return y.measureFromStart(p.b.getLpcBundles),n.i(f.a)(g,t,y)}).then(function(){var t=s(y.getAllTimings());t.RootCorrelationId=g.RootCorrelationId,_.AWT.logEvent({name:"initializeLivePersonaCard_success",properties:t}),u(),e&&e(),r()}).catch(function(t){var e=s(y.getAllTimings());t.type&&(e.ErrorType=t.type),t.message&&(e.ErrorMessage=t.message),t.rootCorrelationId&&(e.RootCorrelationId=t.rootCorrelationId),navigator&&void 0!==typeof navigator.onLine&&(e.IsClientOnline=navigator.onLine),e.IsCatastrophic=!1,_.AWT.logEvent({name:"initializeLivePersonaCard_failure",properties:e}),u(),i&&i("Failed to initialize Live Persona Card: "+t.type),a("Failed to initialize Live Persona Card: "+t.type)})}catch(t){try{_.AWT.logEvent({name:"initializeLivePersonaCard_failure",properties:{IsCatastrophic:!0,Reason:t.toString()},tenantToken:T}),u()}catch(t){console.error("Couldn't log error through ARIA: "+t.toString())}i&&i("Failed to initialize Live Persona Card: "+t.name+" "+t.message),a("Failed to initialize Live Persona Card: "+t.name+" "+t.message)}})}function r(t){return n.i(l.a)(t).then(function(e){return n.i(c.a)(e,t)})}function o(t){_.AWT.initialize(T),_.AWT.setContext("culture",t.culture),_.AWT.setContext("region",t.region),_.AWT.setContext("clientType",t.clientType),_.AWT.setContext("clientContextType",t.clientContextType),_.AWT.setContext("clientCorrelationId",t.clientCorrelationId),_.AWT.setContext("bootstrapperVersion",g)}function s(t){var e={};return Object.keys(t).forEach(function(n){e["Perf_"+n]=t[n].toString()}),e}function u(){_.AWT.flush(function(){})}Object.defineProperty(e,"__esModule",{value:!0}),e.initializeLivePersonaCard=i,e.fetchLokiConfig=r;var a=n(18),c=(n.n(a),n(24)),l=n(23),f=n(26),d=n(25),h=n(32),p=n(29),_=n(5),g=(n.n(_),n(34));n.i(a.polyfill)();var v,T="e5ad760145754ffc9704e67c800087f2-dc72ff20-3e8a-401a-b9a8-ec72e4dd3e22-7257"},function(t,e,n){"use strict";!function(t){t[t.BT_STOP=0]="BT_STOP",t[t.BT_STOP_BASE=1]="BT_STOP_BASE",t[t.BT_UINT8=3]="BT_UINT8",t[t.BT_UINT32=5]="BT_UINT32",t[t.BT_UINT64=6]="BT_UINT64",t[t.BT_STRING=9]="BT_STRING",t[t.BT_STRUCT=10]="BT_STRUCT",t[t.BT_LIST=11]="BT_LIST",t[t.BT_MAP=13]="BT_MAP",t[t.BT_INT32=16]="BT_INT32",t[t.BT_INT64=17]="BT_INT64",t[t.BT_UNAVAILABLE=127]="BT_UNAVAILABLE"}(e.BondDataType||(e.BondDataType={}))},function(t,e,n){"use strict";var i=n(1),r=function(){function t(){}return t.GetBytes=function(t){for(var e=[],n=0;n<t.length;++n){var i=t.charCodeAt(n);i<128?e.push(i):i<2048?e.push(192|i>>6,128|63&i):i<55296||i>=57344?e.push(224|i>>12,128|i>>6&63,128|63&i):(i=65536+((1023&i)<<10|1023&t.charCodeAt(++n)),e.push(240|i>>18,128|i>>12&63,128|i>>6&63,128|63&i))}return e},t}();e.Utf8=r;var o=function(){function t(){}return t.GetString=function(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",n=[],i=t.length%3,r=0,o=t.length-i;r<o;r+=3){var s=(t[r]<<16)+(t[r+1]<<8)+t[r+2];n.push(function(t){return[e.charAt(t>>18&63),e.charAt(t>>12&63),e.charAt(t>>6&63),e.charAt(63&t)].join("")}(s))}switch(i){case 1:var s=t[t.length-1];n.push(e.charAt(s>>2)),n.push(e.charAt(s<<4&63)),n.push("==");break;case 2:var u=(t[t.length-2]<<8)+t[t.length-1];n.push(e.charAt(u>>10)),n.push(e.charAt(u>>4&63)),n.push(e.charAt(u<<2&63)),n.push("=")}return n.join("")},t}();e.Base64=o;var s=function(){function t(){}return t.GetBytes=function(t){for(var e=[];4294967168&t;)e.push(127&t|128),t>>>=7;return e.push(127&t),e},t}();e.Varint=s;var u=function(){function t(){}return t.GetBytes=function(t){for(var e=t.low,n=t.high,i=[];n||4294967168&e;)i.push(127&e|128),e=(127&n)<<25|e>>>7,n>>>=7;return i.push(127&e),i},t}();e.Varint64=u;var a=function(){function t(){}return t.EncodeZigzag32=function(t){return(t=i.Number.ToInt32(t))<<1^t>>31},t.EncodeZigzag64=function(t){var e=t.low,n=t.high,r=n<<1|e>>>31,o=e<<1;2147483648&n&&(r=~r,o=~o);var s=new i.UInt64("0");return s.low=o,s.high=r,s},t}();e.Zigzag=a},function(t,e,n){"use strict";var i=n(1),r=function(){function t(){this._buffer=[]}return t.prototype.WriteByte=function(t){this._buffer.push(i.Number.ToByte(t))},t.prototype.Write=function(t,e,n){for(;n--;)this.WriteByte(t[e++])},t.prototype.GetBuffer=function(){return this._buffer},t}();e.MemoryStream=r},function(t,e,n){"use strict";var i=n(9);e.BondDataType=i.BondDataType;var r=n(10);e.Encoding=r;var o=n(11);e.IO=o;var s=n(1);e.Int64=s.Int64,e.UInt64=s.UInt64,e.Number=s.Number;var u=function(){function t(t){this._stream=t}return t.prototype.WriteBlob=function(t){this._stream.Write(t,0,t.length)},t.prototype.WriteContainerBegin=function(t,e){this.WriteUInt8(e),this.WriteUInt32(t)},t.prototype.WriteMapContainerBegin=function(t,e,n){this.WriteUInt8(e),this.WriteUInt8(n),this.WriteUInt32(t)},t.prototype.WriteFieldBegin=function(t,e){e<=5?this._stream.WriteByte(t|e<<5):e<=255?(this._stream.WriteByte(192|t),this._stream.WriteByte(e)):(this._stream.WriteByte(224|t),this._stream.WriteByte(e),this._stream.WriteByte(e>>8))},t.prototype.WriteInt32=function(t){t=r.Zigzag.EncodeZigzag32(t),this.WriteUInt32(t)},t.prototype.WriteInt64=function(t){this.WriteUInt64(r.Zigzag.EncodeZigzag64(t))},t.prototype.WriteString=function(t){if(""===t)this.WriteUInt32(0);else{var e=r.Utf8.GetBytes(t);this.WriteUInt32(e.length),this._stream.Write(e,0,e.length)}},t.prototype.WriteStructEnd=function(t){this.WriteUInt8(t?i.BondDataType.BT_STOP_BASE:i.BondDataType.BT_STOP)},t.prototype.WriteUInt32=function(t){var e=r.Varint.GetBytes(s.Number.ToUInt32(t));this._stream.Write(e,0,e.length)},t.prototype.WriteUInt64=function(t){var e=r.Varint64.GetBytes(t);this._stream.Write(e,0,e.length)},t.prototype.WriteUInt8=function(t){this._stream.WriteByte(s.Number.ToUInt8(t))},t}();e.CompactBinaryProtocolWriter=u},function(t,e,n){"use strict";var i=function(){function t(){this._killedTokenDictionary={}}return t.prototype.setKillSwitchTenants=function(t,e){var n=this;if(t&&e)try{var i=t.split(",");if("this-request-only"===e)return i;var r=1e3*parseInt(e,10);i.forEach(function(t){n._killedTokenDictionary[t]=Date.now()+r})}catch(t){return[]}return[]},t.prototype.isTenantKilled=function(t){return void 0!==this._killedTokenDictionary[t]&&this._killedTokenDictionary[t]>Date.now()||(delete this._killedTokenDictionary[t],!1)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=i},function(t,e,n){"use strict";var i=n(3),r=function(){function t(t,e){this._maxRequestSize=t,this._outboundQueue=e,this._currentBatch={},this._currentBatchSize=0}return t.prototype.addEventToBatch=function(t){var e=i.default.getEventBlob(t);e.length>this._maxRequestSize||(this._currentBatchSize+e.length>this._maxRequestSize?this.flushBatch():(void 0===this._currentBatch[t.tenantToken]&&(this._currentBatch[t.tenantToken]=[]),this._currentBatch[t.tenantToken].push(e),this._currentBatchSize+=e.length))},t.prototype.flushBatch=function(){this._currentBatchSize>0&&(this._outboundQueue.push(this._currentBatch),this._currentBatch={},this._currentBatchSize=0)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=r},function(t,e,n){"use strict";var i=function(){function t(){}return t.shouldRetryForStatus=function(t){return!(t>=300&&t<500&&408!==t||501===t||505===t)},t.getMillisToBackoffForRetry=function(t){var e=0,n=Math.floor(1200*Math.random())+2400;return e=Math.pow(4,t)*n,Math.min(e,12e4)},t}();Object.defineProperty(e,"__esModule",{value:!0}),e.default=i},function(t,e,n){"use strict";var i=n(2),r=n(17),o=n(4),s=n(6),u=/^[a-zA-Z0-9]([a-zA-Z0-9]|_){2,98}[a-zA-Z0-9]$/,a=/\./g,c=/^[a-zA-Z0-9](([a-zA-Z0-9|_|\.]){0,98}[a-zA-Z0-9])?$/,l=function(){function t(){}return t.initialize=function(t,e){if(void 0===e&&(e={}),this._isInitialized)throw"Already Initialized";this._defaultTenantToken=t,this._overrideValuesFromConfig(e),r.default.initialize(this._config),this._isInitialized=!0},t.flush=function(t){this._isInitialized&&!this._isDestroyed&&r.default.flush(t)},t.flushAndTeardown=function(){this._isInitialized&&!this._isDestroyed&&(this._isDestroyed=!0,r.default.flushAndTeardown())},t.setContext=function(t,e,n){void 0===n&&(n="allTkns"),null!==(e=this._sanitizeProperty(t,e))&&(this._contextProperties[n]||(this._contextProperties[n]={}),this._contextProperties[n][t]=e)},t.logEvent=function(t){var e=this;if(this._isInitialized){if(!t.name||!t.properties)return;t.name=t.name.toLowerCase(),t.name.replace(a,"_");var n="";if(t.type?(t.type.toLowerCase(),n="custom."):t.type="custom",!u.test(t.name)||!u.test(t.type))return;if(t.type=n+t.type,isNaN(t.timestamp)&&(t.timestamp=(new Date).getTime()),t.tenantToken||(t.tenantToken=this._defaultTenantToken),t.id=o.newGuid(),Object.keys(t.properties).forEach(function(n){t.properties[n]=e._sanitizeProperty(n,t.properties[n]),null===t.properties[n]&&delete t.properties[n]}),this._addContextIfAbsent(t,t.tenantToken),this._addContextIfAbsent(t,"allTkns"),0===Object.keys(t.properties).length)return;this._setDefaultProperty(t,"EventInfo.InitId",this._getInitId(t.tenantToken)),this._setDefaultProperty(t,"EventInfo.Sequence",this._getSequenceId(t.tenantToken)),this._setDefaultProperty(t,"EventInfo.SdkVersion",s.FullVersionString),this._setDefaultProperty(t,"EventInfo.Name",t.name),this._setDefaultProperty(t,"EventInfo.Time",new Date(t.timestamp).toISOString()),r.default.sendEvent(t)}},t._overrideValuesFromConfig=function(t){t.collectorUrl&&(this._config.collectorUrl=t.collectorUrl),t.sendingTimer>1e3&&(this._config.sendingTimer=t.sendingTimer)},t._getInitId=function(t){return void 0===this._initIdMap[t]&&(this._initIdMap[t]=o.newGuid()),this._initIdMap[t]},t._getSequenceId=function(t){return void 0===this._sequenceIdMap[t]&&(this._sequenceIdMap[t]=0),(++this._sequenceIdMap[t]).toString()},t._setDefaultProperty=function(t,e,n){t.properties[e]={value:n,pii:i.AWTPiiKind.NotSet}},t._addContextIfAbsent=function(t,e){if(this._contextProperties[e]){var n=this._contextProperties[e];Object.keys(n).forEach(function(e){t.properties[e]||(t.properties[e]=n[e])})}},t._sanitizeProperty=function(t,e){return"string"!=typeof e&&"number"!=typeof e&&"boolean"!=typeof e||(e={value:e}),c.test(t)&&void 0!==e&&null!==e&&null!==e.value&&void 0!==e.value&&""!==e.value?(void 0===e.pii&&(e.pii=i.AWTPiiKind.NotSet),e.value=e.value.toString(),o.isPii(e.pii)?e:null):null},t}();l._isInitialized=!1,l._isDestroyed=!1,l._contextProperties={},l._sequenceIdMap={},l._initIdMap={},l._config={collectorUrl:"https://browser.pipe.aria.microsoft.com/Collector/3.0/",sendingTimer:1e3},Object.defineProperty(e,"__esModule",{value:!0}),e.default=l},function(t,e,n){"use strict";var i=n(14),r=n(3),o=n(15),s=n(13),u=n(6),a=function(){function t(){}return t.initialize=function(t){this._inboundQueues.push([]),this._recordBatcher=new i.default(2936012,this._outboundQueue),this._newEventsAllowed=!0,"undefined"==typeof Uint8Array&&(this._urlString+="&content-encoding=base64"),this._sendingTimer=t.sendingTimer,this._urlString=t.collectorUrl+this._urlString+"&x-apikey="},t.sendEvent=function(t){var e=this;this._newEventsAllowed&&(this._inboundQueues[this._inboundQueues.length-1].push(t),!this._running&&this._timeout<0&&!this._isCurrentlyFlushing&&(this._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},this._sendingTimer)))},t.flushAndTeardown=function(){this._newEventsAllowed=!1,this._batchAndSendEvents(!0)},t.flush=function(t){this._inboundQueues.push([]),this._isCurrentlyFlushing?this._flushQueue.push(t):(this._isCurrentlyFlushing=!0,this._flush(t))},t._batchAndSendEvents=function(t){for(this._running=!0;this._inboundQueues[0].length>0&&this._outboundQueue.length<1;)this._recordBatcher.addEventToBatch(this._inboundQueues[0].pop());0===this._outboundQueue.length&&this._recordBatcher.flushBatch(),this._sendRequest(this._outboundQueue.pop(),0,t)},t._retryRequestIfNeeded=function(t,e,n,i,r){var s=this,u=!0;if(t&&void 0!==t.status){this._killSwitch.setKillSwitchTenants(t.getResponseHeader("kill-tokens"),t.getResponseHeader("kill-duration-seconds")).forEach(function(t){delete e[t],n--}),(!o.default.shouldRetryForStatus(t.status)||n<=0)&&(u=!1)}u&&r<4?setTimeout(function(){return s._sendRequest(e,r+1,!1)},o.default.getMillisToBackoffForRetry(r)):this._handleRequestFinished(null)},t._sendRequest=function(t,e,n){var i=this,o=new XMLHttpRequest,s=0,u="";if(Object.keys(t).forEach(function(e){i._killSwitch.isTenantKilled(e)?delete t[e]:(u.length>0&&(u+=","),u+=e,s++)}),o.open("POST",this._urlString+u,!n),n||(o.ontimeout=function(){i._retryRequestIfNeeded(o,t,s,u,e)},o.onerror=function(){i._retryRequestIfNeeded(o,t,s,u,e)},o.onload=function(){i._handleRequestFinished(o)}),s>0){var a=r.default.getPayloadBlob(t,s);"undefined"==typeof Uint8Array?o.send(r.default.base64Encode(a)):o.send(new Uint8Array(a))}else n&&this._handleRequestFinished(null)},t._handleRequestFinished=function(t){var e=this;t&&this._killSwitch.setKillSwitchTenants(t.getResponseHeader("kill-tokens"),t.getResponseHeader("kill-duration-seconds")),this._inboundQueues[0].length>0?this._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},this._sendingTimer):(this._timeout=-1,this._running=!1)},t._flush=function(t){var e=this;this._running||(this._timeout>-1&&(clearTimeout(this._timeout),this._timeout=-1),this._inboundQueues[0].length>0&&this._batchAndSendEvents(!1)),this._checkPrimaryInboundQueueEmpty(function(){e._inboundQueues.shift(),null!==t&&void 0!==t&&t(),e._flushQueue.length>0?setTimeout(function(){return e._flush(e._flushQueue.shift())},e._sendingTimer):(e._isCurrentlyFlushing=!1,e._inboundQueues[0].length>0&&(e._timeout=setTimeout(function(){return e._batchAndSendEvents(!1)},e._sendingTimer)))})},t._checkPrimaryInboundQueueEmpty=function(t){var e=this;0===this._inboundQueues[0].length?this._checkOutboundQueueEmptyAndSent(t):setTimeout(function(){return e._checkPrimaryInboundQueueEmpty(t)},250)},t._checkOutboundQueueEmptyAndSent=function(t){var e=this;this._running?setTimeout(function(){return e._checkOutboundQueueEmptyAndSent(t)},250):t()},t}();a._outboundQueue=[],a._inboundQueues=[],a._newEventsAllowed=!1,a._killSwitch=new s.default,a._isCurrentlyFlushing=!1,a._flushQueue=[],a._running=!1,a._timeout=-1,a._urlString="?qsp=true&content-type=application%2Fbond-compact-binary&client-id=NO_AUTH&sdk-version="+u.FullVersionString,Object.defineProperty(e,"__esModule",{value:!0}),e.default=a},function(t,e,n){(function(e,i){!function(e,n){t.exports=n()}(0,function(){"use strict";function t(t){return"function"==typeof t||"object"==typeof t&&null!==t}function r(t){return"function"==typeof t}function o(t){Q=t}function s(t){V=t}function u(){return void 0!==G?function(){G(c)}:a()}function a(){var t=setTimeout;return function(){return t(c,1)}}function c(){for(var t=0;t<q;t+=2){(0,Y[t])(Y[t+1]),Y[t]=void 0,Y[t+1]=void 0}q=0}function l(t,e){var n=arguments,i=this,r=new this.constructor(d);void 0===r[tt]&&W(r);var o=i._state;return o?function(){var t=n[o-1];V(function(){return x(o,r,t,i._result)})}():B(i,r,t,e),r}function f(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(d);return m(n,t),n}function d(){}function h(){return new TypeError("You cannot resolve a promise with itself")}function p(){return new TypeError("A promises callback cannot return that same promise.")}function _(t){try{return t.then}catch(t){return rt.error=t,rt}}function g(t,e,n,i){try{t.call(e,n,i)}catch(t){return t}}function v(t,e,n){V(function(t){var i=!1,r=g(n,e,function(n){i||(i=!0,e!==n?m(t,n):I(t,n))},function(e){i||(i=!0,b(t,e))},"Settle: "+(t._label||" unknown promise"));!i&&r&&(i=!0,b(t,r))},t)}function T(t,e){e._state===nt?I(t,e._result):e._state===it?b(t,e._result):B(e,void 0,function(e){return m(t,e)},function(e){return b(t,e)})}function y(t,e,n){e.constructor===t.constructor&&n===l&&e.constructor.resolve===f?T(t,e):n===rt?(b(t,rt.error),rt.error=null):void 0===n?I(t,e):r(n)?v(t,e,n):I(t,e)}function m(e,n){e===n?b(e,h()):t(n)?y(e,n,_(n)):I(e,n)}function w(t){t._onerror&&t._onerror(t._result),A(t)}function I(t,e){t._state===et&&(t._result=e,t._state=nt,0!==t._subscribers.length&&V(A,t))}function b(t,e){t._state===et&&(t._state=it,t._result=e,V(w,t))}function B(t,e,n,i){var r=t._subscribers,o=r.length;t._onerror=null,r[o]=e,r[o+nt]=n,r[o+it]=i,0===o&&t._state&&V(A,t)}function A(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var i=void 0,r=void 0,o=t._result,s=0;s<e.length;s+=3)i=e[s],r=e[s+n],i?x(n,i,r,o):r(o);t._subscribers.length=0}}function S(){this.error=null}function C(t,e){try{return t(e)}catch(t){return ot.error=t,ot}}function x(t,e,n,i){var o=r(n),s=void 0,u=void 0,a=void 0,c=void 0;if(o){if(s=C(n,i),s===ot?(c=!0,u=s.error,s.error=null):a=!0,e===s)return void b(e,p())}else s=i,a=!0;e._state!==et||(o&&a?m(e,s):c?b(e,u):t===nt?I(e,s):t===it&&b(e,s))}function E(t,e){try{e(function(e){m(t,e)},function(e){b(t,e)})}catch(e){b(t,e)}}function k(){return st++}function W(t){t[tt]=st++,t._state=void 0,t._result=void 0,t._subscribers=[]}function P(t,e){this._instanceConstructor=t,this.promise=new t(d),this.promise[tt]||W(this.promise),z(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?I(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&I(this.promise,this._result))):b(this.promise,R())}function R(){return new Error("Array Methods must be provided an Array")}function L(t){return new P(this,t).promise}function O(t){var e=this;return new e(z(t)?function(n,i){for(var r=t.length,o=0;o<r;o++)e.resolve(t[o]).then(n,i)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function D(t){var e=this,n=new e(d);return b(n,t),n}function U(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function M(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function N(t){this[tt]=k(),this._result=this._state=void 0,this._subscribers=[],d!==t&&("function"!=typeof t&&U(),this instanceof N?E(this,t):M())}function F(){var t=void 0;if(void 0!==i)t=i;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var e=t.Promise;if(e){var n=null;try{n=Object.prototype.toString.call(e.resolve())}catch(t){}if("[object Promise]"===n&&!e.cast)return}t.Promise=N}var j=void 0;j=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var z=j,q=0,G=void 0,Q=void 0,V=function(t,e){Y[q]=t,Y[q+1]=e,2===(q+=2)&&(Q?Q(c):$())},H="undefined"!=typeof window?window:void 0,K=H||{},Z=K.MutationObserver||K.WebKitMutationObserver,X="undefined"==typeof self&&void 0!==e&&"[object process]"==={}.toString.call(e),J="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,Y=new Array(1e3),$=void 0;$=X?function(){return function(){return e.nextTick(c)}}():Z?function(){var t=0,e=new Z(c),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}():J?function(){var t=new MessageChannel;return t.port1.onmessage=c,function(){return t.port2.postMessage(0)}}():void 0===H?function(){try{var t=n(35);return G=t.runOnLoop||t.runOnContext,u()}catch(t){return a()}}():a();var tt=Math.random().toString(36).substring(16),et=void 0,nt=1,it=2,rt=new S,ot=new S,st=0;return P.prototype._enumerate=function(){for(var t=this.length,e=this._input,n=0;this._state===et&&n<t;n++)this._eachEntry(e[n],n)},P.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,i=n.resolve;if(i===f){var r=_(t);if(r===l&&t._state!==et)this._settledAt(t._state,e,t._result);else if("function"!=typeof r)this._remaining--,this._result[e]=t;else if(n===N){var o=new n(d);y(o,t,r),this._willSettleAt(o,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(i(t),e)},P.prototype._settledAt=function(t,e,n){var i=this.promise;i._state===et&&(this._remaining--,t===it?b(i,n):this._result[e]=n),0===this._remaining&&I(i,this._result)},P.prototype._willSettleAt=function(t,e){var n=this;B(t,void 0,function(t){return n._settledAt(nt,e,t)},function(t){return n._settledAt(it,e,t)})},N.all=L,N.race=O,N.resolve=f,N.reject=D,N._setScheduler=o,N._setAsap=s,N._asap=V,N.prototype={constructor:N,then:l,catch:function(t){return this.then(null,t)}},N.polyfill=F,N.Promise=N,N})}).call(e,n(22),n(33))},function(t,e){function n(t){this.message=t}function i(t){var e=String(t).replace(/=+$/,"");if(e.length%4==1)throw new n("'atob' failed: The string to be decoded is not correctly encoded.");for(var i,o,s=0,u=0,a="";o=e.charAt(u++);~o&&(i=s%4?64*i+o:o,s++%4)?a+=String.fromCharCode(255&i>>(-2*s&6)):0)o=r.indexOf(o);return a}var r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";n.prototype=new Error,n.prototype.name="InvalidCharacterError",t.exports="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||i},function(t,e,n){function i(t){return decodeURIComponent(r(t).replace(/(.)/g,function(t,e){var n=e.charCodeAt(0).toString(16).toUpperCase();return n.length<2&&(n="0"+n),"%"+n}))}var r=n(19);t.exports=function(t){var e=t.replace(/-/g,"+").replace(/_/g,"/");switch(e.length%4){case 0:break;case 2:e+="==";break;case 3:e+="=";break;default:throw"Illegal base64url string!"}try{return i(e)}catch(t){return r(e)}}},function(t,e,n){"use strict";function i(t){this.message=t}var r=n(20);i.prototype=new Error,i.prototype.name="InvalidTokenError",t.exports=function(t,e){if("string"!=typeof t)throw new i("Invalid token specified");e=e||{};var n=!0===e.header?0:1;try{return JSON.parse(r(t.split(".")[n]))}catch(t){throw new i("Invalid token specified: "+t.message)}},t.exports.InvalidTokenError=i},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function r(t){if(l===setTimeout)return setTimeout(t,0);if((l===n||!l)&&setTimeout)return l=setTimeout,setTimeout(t,0);try{return l(t,0)}catch(e){try{return l.call(null,t,0)}catch(e){return l.call(this,t,0)}}}function o(t){if(f===clearTimeout)return clearTimeout(t);if((f===i||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function s(){_&&h&&(_=!1,h.length?p=h.concat(p):g=-1,p.length&&u())}function u(){if(!_){var t=r(s);_=!0;for(var e=p.length;e;){for(h=p,p=[];++g<e;)h&&h[g].run();g=-1,e=p.length}h=null,_=!1,o(t)}}function a(t,e){this.fun=t,this.array=e}function c(){}var l,f,d=t.exports={};!function(){try{l="function"==typeof setTimeout?setTimeout:n}catch(t){l=n}try{f="function"==typeof clearTimeout?clearTimeout:i}catch(t){f=i}}();var h,p=[],_=!1,g=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];p.push(new a(t,e)),1!==p.length||_||r(u)},a.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=c,d.addListener=c,d.once=c,d.off=c,d.removeListener=c,d.removeAllListeners=c,d.emit=c,d.prependListener=c,d.prependOnceListener=c,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";function i(t){return o=o||new Promise(function(e,i){t.authToken?(n.i(s.a)(c,t.authToken),e(t.authToken)):t.getAuthToken(function(t,r){t?(n.i(s.a)(c,t),e(t)):i(new u.a("GetAuthTokenError","Auth token is undefined",r))},function(t,e){i(new u.a("GetAuthTokenError",t,e))})})}function r(t){if(!t)throw Error("Empty AuthToken");var e=a(t);return{tenantId:e.tid,userAadId:e.oid,userPuid:e.puid,expirationTimeEpoch:e.exp}}e.a=i,e.b=r;var o,s=n(30),u=n(0),a=n(21),c=(n.n(a),"LokiAuthToken")},function(t,e,n){"use strict";function i(t,e){return o=o||new Promise(function(i,o){var c=new XMLHttpRequest,l=r(e);c.open("GET",l,!0),c.setRequestHeader("authToken",t),c.setRequestHeader("Accept","application/json");var h=n.i(u.a)();c.setRequestHeader("X-RootCorrelationId",h),c.setRequestHeader("X-CorrelationId",h),c.setRequestHeader("X-ClientCorrelationId",e.clientCorrelationId),c.setRequestHeader("X-ClientType",e.clientType);var p=n.i(s.a)(d);p&&c.setRequestHeader(d,p),c.addEventListener("load",function(){if(200===c.status)try{var t=JSON.parse(c.response);t.RootCorrelationId=h,t.LokiVersion=c.getResponseHeader("x-serverversion")||"",i(t)}catch(t){o(new a.a("GetLokiConfigError","Failed to parse initialization config.",h))}else o(new a.a("GetLokiConfigError","Couldn't retrieve initialization config. Status code is "+c.status,h))}),c.addEventListener("error",function(){o(new a.a("GetLokiConfigError","Couldn't retrieve initialization config, request failed to complete.",h))}),c.addEventListener("timeout",function(){o(new a.a("GetLokiConfigError","Loki config request timed out after "+f+" ms.",h))}),c.timeout=f,c.send()})}function r(t){var e=n.i(s.a)(h),i=e||t.culture;return"ppe"===t.region||"df"===t.region||"msit"===t.region?c.replace("{0}",t.region).replace("{1}",t.clientType).replace("{2}",i):l.replace("{0}",t.clientType).replace("{1}",i)}e.a=i;var o,s=n(7),u=n(27),a=n(0),c="https://{0}.loki.delve.office.com/api/v1/configuration/{1}/{2}",l="https://loki.delve.office.com/api/v1/configuration/{0}/{1}",f=6e4,d="LivePersonaCardVersionOverride",h="LivePersonaCardCultureOverride"},function(t,e,n){"use strict";function i(t){if(!o){var e=t.Resources[l],i=void 0;n.i(u.a)("lpcUseLocalBuild")?(e="https://localhost:3333/assets/livepersonacardstrings.js",i="https://localhost:3333/assets/livepersonacard.js"):i=r()?t.Resources[c]:t.Resources[a],o=Promise.all([n.i(s.a)(e),n.i(s.a)(i)])}return o}function r(){return window.React&&window.React.version&&0===window.React.version.indexOf("15.")&&window.ReactDOM&&window.ReactDOM.version&&0===window.ReactDOM.version.indexOf("15.")}e.a=i;var o,s=n(28),u=n(7),a="livepersonacard_full",c="livepersonacard_global",l="livepersonacardstrings"},function(t,e,n){"use strict";function i(t,e,n){return s=s||new Promise(function(i,o){try{var s=r(t,e,n);window.LPC.start(s),i()}catch(t){o(new u.a("StartLivePersonaCardError",t.name+" "+t.message))}})}function r(t,e,n){return{refreshAuthToken:o(e),logToExternalApplication:e.logMessage,logToExternalAria:function(t,e){t.tenantToken=e,a.AWT.logEvent(t)},contextType:e.clientContextType,strings:window.LivePersonaCardStrings.strings,source:e.clientType,consumerCorrelationId:e.clientCorrelationId,activeFlights:t.Flights,performanceTimings:n.getAllTimings(),isDebug:!1,region:e.region,culture:e.culture,dataCallbacks:e.dataCallbacks,actionCallbacks:e.actionCallbacks,privateDataCallbacks:e.privateDataCallbacks,privateActionCallbacks:e.privateActionCallbacks,options:e.options?e.options:{isImmersiveProfileEnabled:!1,isLinkedInIntegrationEnabled:!1,hideDocumentFilter:!1},lokiUrl:t.LokiUrl,lokiVersion:t.LokiVersion,tenantAadObjectId:e.tenantAadObjectId,userAadObjectId:e.userAadObjectId,userPuid:e.userPuid}}function o(t){return function(e){t.getAuthToken(function(t,n){e(t,"",n)},function(t,n){e("",t,n)})}}e.a=i;var s,u=n(0),a=n(5);n.n(a)},function(t,e,n){"use strict";function i(){return r.replace(/[xy]/g,function(t){var e;if(window.crypto){var n=new Uint8Array(1);window.crypto.getRandomValues(n),e=n[0]}else e=Math.floor(16*Math.random());return("x"===t?e%16:e%4+8).toString(16)})}e.a=i;var r="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"},function(t,e,n){"use strict";function i(t){return new Promise(function(e,n){var i=document.createElement("script");i.type="text/javascript",i.crossOrigin="anonymous",i.src=t,i.addEventListener("load",function(){e()}),i.addEventListener("error",function(){n(new r.a("LoadScriptError","Unexpected error while loading script on page."))}),document.body.appendChild(i)})}e.a=i;var r=n(0)},function(t,e,n){"use strict";n.d(e,"b",function(){return i}),n.d(e,"a",function(){return r});var i;!function(t){t.getAuthToken="GetAuthTokenFromStartDuration",t.getLokiConfig="GetLokiConfigFromStartDuration",t.getLpcBundles="GetLpcBundlesFromStartDuration"}(i||(i={}));var r=function(){function t(){this.start=this.getCurrentTime(),this.timings={}}return t.prototype.measureFromStart=function(t){this.timings[t]=Math.round(this.getCurrentTime()-this.start)},t.prototype.getAllTimings=function(){var t=this;if(window.performance&&"function"==typeof window.performance.getEntriesByType){var e=window.performance.getEntriesByType("resource");e&&e.forEach(function(e){if(e&&e.name){var n=e.name.toLowerCase(),i=!1;-1!==n.indexOf("authtoken/loki")?(n="AuthRequestDuration",i=!0):-1!==n.indexOf("/lpc/versionless/livepersonacard_")?(n="LpcBundleRequestDuration",i=!0):-1!==n.indexOf("/lpc/versionless/livepersonacardstrings")?(n="LpcStringsRequestDuration",i=!0):-1!==n.indexOf("/api/v1/configuration/")&&(n="InitConfigRequestDuration",i=!0),i&&(t.timings[n]=Math.round(e.duration))}})}return this.timings},t.prototype.getCurrentTime=function(){return window.performance&&"function"==typeof window.performance.now?performance.now():Date.now()},t}()},function(t,e,n){"use strict";function i(t,e){try{sessionStorage&&sessionStorage.setItem&&sessionStorage.setItem(t,e)}catch(t){}}e.a=i},function(t,e,n){"use strict";function i(t){return void 0===t||"string"!=typeof t||""===t||null===t}function r(t){return void 0===t||"function"!=typeof t}e.a=i,e.b=r},function(t,e,n){"use strict";function i(t){return new Promise(function(e,n){var i=r(t);i?n(new s.a("ValidateBootstrapperConfigError",i)):e()})}function r(t){var e="";if(t){var i=[];n.i(o.a)(t.culture)&&i.push("culture"),n.i(o.a)(t.clientType)&&i.push("clientType"),n.i(o.a)(t.clientContextType)&&i.push("clientContextType"),n.i(o.a)(t.clientCorrelationId)&&i.push("clientCorrelationId"),n.i(o.b)(t.logMessage)&&i.push("logMessage"),n.i(o.b)(t.getAuthToken)&&i.push("getAuthToken"),i.length>0&&(e="Invalid required parameter(s): "+i.join(", ")+". Check the values and types you're passing."),t.region&&-1===u.indexOf(t.region.toLowerCase().trim())&&(e+="Invalid region value. Allowed values are: empty string for production environments, and "+u.join(", ")+" for pre-production environments.")}else e="Config must be defined.";return e}e.a=i;var o=n(31),s=n(0),u=["msit","df","ppe"]},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e){t.exports="1.3.14"},function(t,e){},function(t,e,n){t.exports=n(8)}])});

/***/ }),

/***/ 2655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var PersonaCard_1 = __webpack_require__(2710);
var Store_1 = __webpack_require__(327);
var initializeLivePersonaCard_1 = __webpack_require__(2713);
var owa_people_loki_1 = __webpack_require__(2644);
var owa_string_utils_1 = __webpack_require__(2627);
var mobx_react_1 = __webpack_require__(11);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var HOVER_DELAY_MS = 500;
var LivePersonaCardPersonaTypes = {
    NotResolved: 'NotResolved',
    User: 'User',
    Group: 'Group',
    External: 'External',
    DistributionList: 'DistributionList',
    PrivateDistributionList: 'PrivateDistributionList',
    Location: 'Location',
    Room: 'Room',
    Meeting: 'Meeting',
};
var personaCardDiv;
var LegacyPersonaCardBehavior = /** @class */ (function (_super) {
    tslib_1.__extends(LegacyPersonaCardBehavior, _super);
    function LegacyPersonaCardBehavior(props) {
        var _this = _super.call(this, props) || this;
        _this.onElementClicked = function (ev) {
            ev.stopPropagation();
            _this.openPersonaCard();
        };
        _this.openPersonaCard = function () {
            if (!personaCardDiv) {
                personaCardDiv = document.createElement('div');
                personaCardDiv.id = 'personaCard';
                document.body.appendChild(personaCardDiv);
            }
            var _a = _this.props, name = _a.name, emailAddress = _a.emailAddress;
            if (name && emailAddress) {
                ReactDOM.render(React.createElement(PersonaCard_1.default, { emailAddress: emailAddress, name: name, targetElement: _this.wrappedElement, onDismiss: _this.closePersonaCard }), personaCardDiv);
            }
        };
        _this.closePersonaCard = function (ev) {
            ReactDOM.unmountComponentAtNode(personaCardDiv);
        };
        _this.onElementHover = function () {
            _this.openPersonaCard();
        };
        _this.onElementMouseEnter = function (ev) {
            _this.hoverTimerId = setTimeout(_this.onElementHover, HOVER_DELAY_MS);
        };
        _this.onElementMouseLeave = function (ev) {
            if (_this.hoverTimerId) {
                clearTimeout(_this.hoverTimerId);
                _this.hoverTimerId = undefined;
            }
        };
        _this.getElement = function (wrappedElement) {
            _this.wrappedElement = ReactDOM.findDOMNode(wrappedElement);
        };
        return _this;
    }
    LegacyPersonaCardBehavior.prototype.render = function () {
        return (React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props, { onPersonaCardBehaviorClick: this.onElementClicked, onPersonaCardBehaviorMouseEnter: this.onElementMouseEnter, onPersonaCardBehaviorMouseLeave: this.onElementMouseLeave, ref: this.getElement })));
    };
    return LegacyPersonaCardBehavior;
}(React.Component));
var LivePersonaCardBehavior = /** @class */ (function (_super) {
    tslib_1.__extends(LivePersonaCardBehavior, _super);
    function LivePersonaCardBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LivePersonaCardBehavior.prototype.componentDidMount = function () {
        initializeLivePersonaCard_1.default(this.props.composeEmailOverride);
    };
    LivePersonaCardBehavior.prototype.render = function () {
        if (Store_1.default.isLivePersonaCardInitialized) {
            var LivePersonaCardHoverTarget = window.LivePersonaCardHoverTarget;
            return (React.createElement(LivePersonaCardHoverTarget, { upn: this.props.emailAddress, externalAppSessionCorrelationId: owa_people_loki_1.lokiClientCorrelationId, disableHoverAndKeyPress: this.props.disableHoverAndKeyPress, hostAppPersonaInfo: {
                    PersonaType: calculatePersonaType(this.props.mailBoxType, this.props.personaType),
                    PersonaDisplayName: this.props.name,
                    OlsPersonaId: this.props.olsPersonaId,
                } },
                React.createElement("span", { className: this.props.className, "aria-label": this.props.ariaLabel },
                    React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props)))));
        }
        else {
            return React.createElement(this.props.InputTemplate, tslib_1.__assign({}, this.props));
        }
    };
    LivePersonaCardBehavior = tslib_1.__decorate([
        mobx_react_1.observer
    ], LivePersonaCardBehavior);
    return LivePersonaCardBehavior;
}(React.Component));
function calculatePersonaType(mailBoxType, personaType) {
    if (!owa_string_utils_1.isNullOrWhiteSpace(mailBoxType)) {
        return getLivePersonaCardPersonaTypeFromMailBoxType(mailBoxType);
    }
    if (!owa_string_utils_1.isNullOrWhiteSpace(personaType) &&
        Object.keys(LivePersonaCardPersonaTypes).indexOf(personaType) > -1) {
        return personaType;
    }
    if (owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl')) {
        return 'User';
    }
    return 'NotResolved';
}
function getLivePersonaCardPersonaTypeFromMailBoxType(mailBoxType) {
    switch (mailBoxType) {
        case 'PublicDL':
            return LivePersonaCardPersonaTypes.DistributionList;
        case 'PrivateDL':
            return LivePersonaCardPersonaTypes.PrivateDistributionList;
        case 'GroupMailbox':
            return LivePersonaCardPersonaTypes.Group;
        case 'Mailbox':
        case 'Contact':
        case 'OneOff':
            return LivePersonaCardPersonaTypes.User;
        case 'Unknown':
            return LivePersonaCardPersonaTypes.NotResolved;
        default:
            return LivePersonaCardPersonaTypes.User;
    }
}
function personaCardBehavior(InputTemplate) {
    return mobx_react_1.observer(/** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var ComponentClass = owa_controls_feature_flags_1.isControlFeatureEnabled('rp-livePersonaCard')
                ? LivePersonaCardBehavior
                : LegacyPersonaCardBehavior;
            return React.createElement(ComponentClass, tslib_1.__assign({ InputTemplate: InputTemplate }, this.props));
        };
        return class_1;
    }(React.Component)));
}
exports.personaCardBehavior = personaCardBehavior;
//# sourceMappingURL=PersonaCardBehavior.js.map

/***/ }),

/***/ 2676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if a given string is null, empty, or consists only of white-space characters.
 * @param text: the string to check
 */
function isNullOrWhiteSpace(text) {
    return text == null || text.trim().length == 0;
}
exports.isNullOrWhiteSpace = isNullOrWhiteSpace;
//# sourceMappingURL=isNullOrWhiteSpace.js.map

/***/ }),

/***/ 2678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getClientAccessTokenJsonRequest_1 = __webpack_require__(2679);
function getClientAccessTokenOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = getClientAccessTokenJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("GetClientAccessToken", req, options);
}
exports.default = getClientAccessTokenOperation;


/***/ }),

/***/ 2679:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getClientAccessTokenJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetClientAccessTokenJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = getClientAccessTokenJsonRequest;


/***/ }),

/***/ 2680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getClientAccessTokenRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetClientAccessTokenRequest:#Exchange' }, data);
    return result;
}
exports.default = getClientAccessTokenRequest;


/***/ }),

/***/ 2682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2683), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2683:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Icon_1 = __webpack_require__(43);
var Utilities_2 = __webpack_require__(7);
var Checkbox_classNames_1 = __webpack_require__(2684);
var Checkbox_styles_1 = __webpack_require__(2640);
var Checkbox = /** @class */ (function (_super) {
    tslib_1.__extends(Checkbox, _super);
    /**
     * Initialize a new instance of the TopHeaderV2
     * @param props Props for the component
     * @param context Context or initial state for the base component.
     */
    function Checkbox(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._warnMutuallyExclusive({
            'checked': 'defaultChecked'
        });
        _this._id = Utilities_1.getId('checkbox-');
        _this.state = {
            isChecked: !!(props.checked !== undefined ? props.checked : props.defaultChecked)
        };
        return _this;
    }
    Checkbox.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.checked !== undefined) {
            this.setState({
                isChecked: !!newProps.checked // convert null to false
            });
        }
    };
    /**
     * Render the Checkbox based on passed props
     */
    Checkbox.prototype.render = function () {
        var _a = this.props, checked = _a.checked, className = _a.className, defaultChecked = _a.defaultChecked, disabled = _a.disabled, inputProps = _a.inputProps, name = _a.name, boxSide = _a.boxSide, theme = _a.theme, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, customStyles = _a.styles, _b = _a.onRenderLabel, onRenderLabel = _b === void 0 ? this._onRenderLabel : _b, checkmarkIconProps = _a.checkmarkIconProps;
        var isChecked = checked === undefined ? this.state.isChecked : checked;
        var isReversed = boxSide !== 'start' ? true : false;
        this._classNames = this.props.getClassNames ?
            this.props.getClassNames(theme, !!disabled, !!isChecked, !!isReversed, className)
            : Checkbox_classNames_1.getClassNames(Checkbox_styles_1.getStyles(theme, customStyles), !!disabled, !!isChecked, !!isReversed, className);
        return (React.createElement("button", tslib_1.__assign({}, inputProps, (checked !== undefined && { checked: checked }), (defaultChecked !== undefined && { defaultChecked: defaultChecked }), { disabled: disabled, ref: this._resolveRef('_checkBox'), name: name, id: this._id, role: 'checkbox', type: 'button', className: this._classNames.root, onClick: this._onClick, onFocus: this._onFocus, onBlur: this._onBlur, "aria-checked": isChecked, "aria-disabled": disabled, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }),
            React.createElement("label", { className: this._classNames.label, htmlFor: this._id },
                React.createElement("div", { className: this._classNames.checkbox },
                    React.createElement(Icon_1.Icon, tslib_1.__assign({ iconName: 'CheckMark' }, checkmarkIconProps, { className: this._classNames.checkmark }))),
                onRenderLabel(this.props, this._onRenderLabel))));
    };
    Object.defineProperty(Checkbox.prototype, "checked", {
        get: function () {
            return this.state.isChecked;
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.focus = function () {
        if (this._checkBox) {
            this._checkBox.focus();
        }
    };
    Checkbox.prototype._onFocus = function (ev) {
        var inputProps = this.props.inputProps;
        if (inputProps && inputProps.onFocus) {
            inputProps.onFocus(ev);
        }
    };
    Checkbox.prototype._onBlur = function (ev) {
        var inputProps = this.props.inputProps;
        if (inputProps && inputProps.onBlur) {
            inputProps.onBlur(ev);
        }
    };
    Checkbox.prototype._onClick = function (ev) {
        var _a = this.props, disabled = _a.disabled, onChange = _a.onChange;
        var isChecked = this.state.isChecked;
        ev.preventDefault();
        ev.stopPropagation();
        if (!disabled) {
            if (onChange) {
                onChange(ev, !isChecked);
            }
            if (this.props.checked === undefined) {
                this.setState({ isChecked: !isChecked });
            }
        }
    };
    Checkbox.prototype._onRenderLabel = function (props) {
        var label = props.label;
        return label ? (React.createElement("span", { className: this._classNames.text }, label)) : (null);
    };
    Checkbox.defaultProps = {
        boxSide: 'start'
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Checkbox.prototype, "_onFocus", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Checkbox.prototype, "_onBlur", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Checkbox.prototype, "_onClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Checkbox.prototype, "_onRenderLabel", null);
    Checkbox = tslib_1.__decorate([
        Utilities_2.customizable('Checkbox', ['theme'])
    ], Checkbox);
    return Checkbox;
}(Utilities_1.BaseComponent));
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map

/***/ }),

/***/ 2684:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
exports.getClassNames = Utilities_1.memoizeFunction(function (styles, disabled, isChecked, isReversed, className) {
    return {
        root: Styling_1.mergeStyles('ms-Checkbox', isReversed && 'reversed', isChecked && 'is-checked', !disabled && 'is-enabled', disabled && 'is-disabled', className, styles.root, !disabled && [
            !isChecked && {
                selectors: {
                    ':hover .ms-Checkbox-checkbox': styles.checkboxHovered,
                    ':focus .ms-Checkbox-checkbox': styles.checkboxFocused
                }
            },
            isChecked && {
                selectors: {
                    ':hover .ms-Checkbox-checkbox': styles.checkboxCheckedHovered,
                    ':focus .ms-Checkbox-checkbox': styles.checkboxCheckedFocused
                }
            },
            {
                selectors: {
                    ':hover .ms-Checkbox-text': styles.textHovered,
                    ':focus .ms-Checkbox-text': styles.textFocused
                }
            }
        ]),
        label: Styling_1.mergeStyles('ms-Checkbox-label', styles.label, isReversed && styles.labelReversed, disabled && styles.labelDisabled),
        checkbox: Styling_1.mergeStyles('ms-Checkbox-checkbox', styles.checkbox, !disabled && isChecked && styles.checkboxChecked, disabled && !isChecked && styles.checkboxDisabled, disabled && isChecked && styles.checkboxCheckedDisabled),
        checkmark: Styling_1.mergeStyles(styles.checkmark, !disabled && isChecked && styles.checkmarkChecked, disabled && !isChecked && styles.checkmarkDisabled, disabled && isChecked && styles.checkmarkCheckedDisabled),
        text: Styling_1.mergeStyles('ms-Checkbox-text', styles.text, disabled && styles.textDisabled),
    };
});
//# sourceMappingURL=Checkbox.classNames.js.map

/***/ }),

/***/ 2710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var PersonaControl_1 = __webpack_require__(673);
var Callout_1 = __webpack_require__(157);
var Persona_1 = __webpack_require__(234);
var styles = __webpack_require__(2711);
var PersonaCard = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaCard, _super);
    function PersonaCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseLeave = function (ev) {
            _this.props.onDismiss(ev);
        };
        return _this;
    }
    PersonaCard.prototype.render = function () {
        var _a = this.props, emailAddress = _a.emailAddress, name = _a.name, targetElement = _a.targetElement, onDismiss = _a.onDismiss;
        if (!targetElement) {
            return null;
        }
        return (React.createElement(Callout_1.Callout, { target: targetElement, directionalHint: 4 /* bottomLeftEdge */, isBeakVisible: false, onDismiss: onDismiss },
            React.createElement("div", { onMouseLeave: this.onMouseLeave, className: styles.container },
                React.createElement(PersonaControl_1.default, { name: name, emailAddress: emailAddress, size: Persona_1.PersonaSize.large, showPersonaDetails: true, secondaryText: emailAddress }))));
    };
    PersonaCard = tslib_1.__decorate([
        mobx_react_1.observer
    ], PersonaCard);
    return PersonaCard;
}(React.Component));
exports.default = PersonaCard;
//# sourceMappingURL=PersonaCard.js.map

/***/ }),

/***/ 2711:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(2712);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._2ZbqoLMzvSVTB15DLsl21H{padding:10px}._2ZbqoLMzvSVTB15DLsl21H .ms-Persona-details{-webkit-touch-callout:text;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:auto}", ""]);

// exports
exports.locals = {
	"container": "_2ZbqoLMzvSVTB15DLsl21H"
};

/***/ }),

/***/ 2713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var initializeLivePersonaCardAsync_1 = __webpack_require__(2714);
var Store_1 = __webpack_require__(327);
var owa_trace_1 = __webpack_require__(14);
var owa_bundling_1 = __webpack_require__(6);
var lazyStyles = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 2936));
});
var handleInitializeLivePersonaCard = legacy_1.action('handleInitializeLivePersonaCard')(function () {
    Store_1.default.isLivePersonaCardInitialized = true;
});
var livePersonaCardFailedToInitialize = false;
var initializationPromise = null;
exports.default = legacy_1.action('initializeLivePersonaCard')(function initializeLivePersonaCard(composeEmailOverride) {
    if (!initializationPromise &&
        !Store_1.default.isLivePersonaCardInitialized &&
        !livePersonaCardFailedToInitialize) {
        // TMP: Dynamically load css for card.  LPC will eventually fix this
        // and ship with the required fonts.
        lazyStyles.import();
        initializationPromise = initializeLivePersonaCardAsync_1.default(composeEmailOverride)
            .then(handleInitializeLivePersonaCard)
            .catch(function (reason) {
            initializationPromise = null;
            livePersonaCardFailedToInitialize = true;
            owa_trace_1.trace.error(reason);
        });
    }
});
//# sourceMappingURL=initializeLivePersonaCard.js.map

/***/ }),

/***/ 2714:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_analytics_1 = __webpack_require__(12);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_people_loki_1 = __webpack_require__(2644);
var getPersonaPhotoUrl_1 = __webpack_require__(345);
var getHexConsumerIdForUser_1 = __webpack_require__(1579);
var Persona_1 = __webpack_require__(234);
var getPersonaPhotoUrl_2 = __webpack_require__(345);
var store_1 = __webpack_require__(49);
var personaConfig_1 = __webpack_require__(1777);
var initializeLivePersonaCardPromise;
function initializeLivePersonaCardAsync(composeEmailOverride) {
    var config = personaConfig_1.getConfig();
    initializeLivePersonaCardPromise =
        initializeLivePersonaCardPromise ||
            new Promise(function (resolve, reject) {
                var actionCallbacks = {
                    composeMail: function (recipient, subject, body) {
                        if (composeEmailOverride) {
                            composeEmailOverride(recipient, recipient);
                        }
                        else if (config.actionCallbacks && config.actionCallbacks.composeMail) {
                            config.actionCallbacks.composeMail(recipient, subject, body);
                        }
                        // Compose view is triggered in existing window, therefore dismiss card so it's not left hanging without an anchor
                        window.LPC.dismissCard();
                    },
                };
                var dataCallbacks = {
                    getAndPrefetchPersonaImageUri: function (personaId, callback) {
                        var hexCid = getHexConsumerIdForUser_1.default(personaId.Smtp);
                        callback(hexCid
                            ? getPersonaPhotoUrl_2.getPersonaPhotoUrlFromhexCID(hexCid, Persona_1.PersonaSize.regular)
                            : getPersonaPhotoUrl_1.default(personaId.Smtp));
                    },
                };
                if (config.actionCallbacks && config.actionCallbacks.toggleFavoritePerson) {
                    actionCallbacks.toggleFavoritePerson = config.actionCallbacks.toggleFavoritePerson;
                }
                if (config.dataCallbacks && config.dataCallbacks.getIsPersonFavorited) {
                    dataCallbacks.getIsPersonFavorited = config.dataCallbacks.getIsPersonFavorited;
                }
                var isConsumer = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
                var culture = store_1.default.userConfiguration.SessionSettings.UserCulture;
                var tenantId = store_1.default.userConfiguration.SessionSettings.TenantGuid;
                var useDogfood = owa_controls_feature_flags_1.isControlFeatureEnabled('peo-lokiDogfood');
                var timeFormat = store_1.default.userConfiguration.UserOptions.TimeFormat;
                var is24HourFormat = timeFormat && timeFormat.indexOf('tt') === -1;
                var logger = function (eventName, customData) {
                    owa_analytics_1.logUsage(eventName, customData);
                };
                owa_people_loki_1.initializeLoki({
                    culture: culture,
                    isConsumer: isConsumer,
                    useDogfood: useDogfood,
                    logger: logger,
                    tenantId: tenantId,
                });
                var bootstrapperConfig = owa_people_loki_1.getLokiBootstrapperConfig();
                var lpcBootstrapperConfig = tslib_1.__assign({}, bootstrapperConfig, { actionCallbacks: actionCallbacks, dataCallbacks: dataCallbacks, options: {
                        isLinkedInIntegrationEnabled: false,
                        timeFormat: timeFormat,
                        is24HourFormat: is24HourFormat,
                    } });
                owa_people_loki_1.initializeLivePersonaCard(lpcBootstrapperConfig, function () {
                    resolve();
                }, function (errorMessage) {
                    reject(errorMessage);
                });
            });
    return initializeLivePersonaCardPromise;
}
exports.default = initializeLivePersonaCardAsync;
//# sourceMappingURL=initializeLivePersonaCardAsync.js.map

/***/ }),

/***/ 2715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authToken_1 = __webpack_require__(2647);
exports.AuthToken = authToken_1.AuthToken;
var authTokenProvider_1 = __webpack_require__(2723);
exports.AuthTokenProvider = authTokenProvider_1.AuthTokenProvider;
var authUtils_1 = __webpack_require__(2649);
exports.getAuthToken = authUtils_1.getAuthToken;
exports.setAuthToken = authUtils_1.setAuthToken;
exports.setAuthTokenOnUrl = authUtils_1.setAuthTokenOnUrl;
exports.clearAuthToken = authUtils_1.clearAuthToken;
exports.removeAuthTokenFromUrl = authUtils_1.removeAuthTokenFromUrl;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = __webpack_require__(2648);
function isLokiEndpoint(url) {
    if (StringUtils_1.isNullOrEmpty(url)) {
        return false;
    }
    var regex = new RegExp("^https://.+.loki.delve.office.com/.*", "i");
    return regex.test(url);
}
exports.isLokiEndpoint = isLokiEndpoint;
//# sourceMappingURL=isLokiEndpoint.js.map

/***/ }),

/***/ 2717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copied from Oslo code
// General base64 util based on this repo https://github.com/mathiasbynens/base64
// If you want to modify/change this code, consider this package instead - https://www.npmjs.com/package/atob
Object.defineProperty(exports, "__esModule", { value: true });
// This is just used for browsers <= IE9, for normal browsers use btoa and atob
var TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// From http://whatwg.org/html/common-microsyntaxes.html#space-character
var REGEX_SPACE_CHARACTERS = /<%= spaceCharacters %>/g;
/**
 * `decode` is designed to be fully compatible with `atob` as described in the
 * HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
 */
/* tslint:disable:no-bitwise */
function decode(input) {
    input = String(input).replace(REGEX_SPACE_CHARACTERS, "");
    var length = input.length;
    if (length % 4 === 0) {
        input = input.replace(/==?$/, "");
        length = input.length;
    }
    if (length % 4 === 1 || /[^+a-zA-Z0-9/]/.test(input)) {
        error("Invalid character: the string to be decoded is not correctly encoded.");
    }
    var bitCounter = 0;
    var bitStorage = 0;
    var buffer;
    var output = "";
    var position = -1;
    while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
        // Unless this is the first of a group of 4 characters…
        if (bitCounter++ % 4) {
            // …convert the first 8 bits to a single ASCII character.
            output += String.fromCharCode(0xff & (bitStorage >> ((-2 * bitCounter) & 6)));
        }
    }
    return output;
}
exports.decode = decode;
/** `encode` is designed to be fully compatible with `btoa` as described in the
 *  HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
 */
function encode(input) {
    input = String(input);
    if (/[^\0-\xFF]/.test(input)) {
        // Note: no need to special-case astral symbols here, as surrogates are
        // Matched, and the input is supposed to only contain ASCII anyway.
        error("The string to be encoded contains characters outside of the 'Latin1 range.");
    }
    var padding = input.length % 3;
    var output = "";
    var position = -1;
    var a;
    var b;
    var c;
    var buffer;
    // Make sure any padding is handled outside of the loop.
    var length = input.length - padding;
    while (++position < length) {
        // Read three bytes, i.e. 24 bits.
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c;
        // Turn the 24 bits into four chunks of 6 bits each, and append the
        // Matching character for each of them to the output.
        output +=
            TABLE.charAt((buffer >> 18) & 0x3f) +
                TABLE.charAt((buffer >> 12) & 0x3f) +
                TABLE.charAt((buffer >> 6) & 0x3f) +
                TABLE.charAt(buffer & 0x3f);
    }
    if (padding === 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += TABLE.charAt(buffer >> 10) + TABLE.charAt((buffer >> 4) & 0x3f) + TABLE.charAt((buffer << 2) & 0x3f) + "=";
    }
    else if (padding === 1) {
        buffer = input.charCodeAt(position);
        output += TABLE.charAt(buffer >> 2) + TABLE.charAt((buffer << 4) & 0x3f) + "==";
    }
    return output;
}
exports.encode = encode;
function error(message) {
    var error = new Error(message);
    error.name = "InvalidCharacterError";
    throw new Error(message);
}
//# sourceMappingURL=Base64.js.map

/***/ }),

/***/ 2718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Filters out null and undefined values from an array.
 * @param array The array to filter.
 */
function filterOutNull(array) {
    return array.filter(function (x) { return x !== null && x !== undefined; });
}
exports.filterOutNull = filterOutNull;
/**
 * Returns copy of the given object with all null, undefined, empty string and empty array values removed.
 *
 * The return type isn't totally correct, since it claims that we _can_ return keys with undefined values. It would be neat if we could
 * apply Partial only to the falsyable values, but at least we preserve a defensive version of the incoming type, so that you can't
 * accidentally pass the output to something expecting something completely different.
 */
function omitEmpty(o) {
    return pickBy(o, function (val) { return val !== undefined && val !== null && val !== "" && (!(val instanceof Array) || val.length > 0); });
}
exports.omitEmpty = omitEmpty;
function pickBy(o, pred) {
    if (o === undefined || o === null) {
        return o;
    }
    var ret = {};
    for (var _i = 0, _a = Object.keys(o); _i < _a.length; _i++) {
        var key = _a[_i];
        if (pred(o[key])) {
            ret[key] = o[key];
        }
    }
    return ret;
}
/*
 * Given a "current" and an "update" object, return a new object with the merged properties of current and update, with precedence given to
 * update. The function ensures that update is an exact subset of current. I.e. update cannot (normally) introduce any keys that don't
 * already exist in current.
 *
 * The exception to this rule occurs if update is _not_ a literal object and contains extra properties _in addition_ to all the properties
 * in current. This is an effect of the type checking system, which tends to be more relaxed about object expressions than literal objects.
 *
 * As an example:
 *
 * Given interface I { a: number, b: number},
 * keyof I is "a" | "b"
 * [key in K]: I[K] is an indexer mapping keys to their respective types in I. This will fail for keys that are not in I, since they cannot
 * be mapped.
 *
 * This signature looks very much like Partial<T> and is indeed almost the same thing. However, since Partial marks all its properties as
 * optional, all of them will have undefined as a valid type. We very much don't want the update object to accidentally set non-nullable
 * properties to undefined, so this means we can't use Partial<T>
 */
function updateWith(current, update) {
    return Object.assign({}, current, update);
}
exports.updateWith = updateWith;
//# sourceMappingURL=Functional.js.map

/***/ }),

/***/ 2719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MemoryStorageUtils = __webpack_require__(2720);
var SessionStorageUtils = __webpack_require__(2721);
function clear(appId) {
    MemoryStorageUtils.clear(appId);
    SessionStorageUtils.clear();
}
exports.clear = clear;
function setItem(key, value, appId) {
    MemoryStorageUtils.setItem(key, value, appId);
    SessionStorageUtils.setItem(key, value);
}
exports.setItem = setItem;
function getItem(key, appId) {
    var val = SessionStorageUtils.getItem(key);
    if (val !== undefined) {
        return val;
    }
    return MemoryStorageUtils.getItem(key, appId);
}
exports.getItem = getItem;
function removeItem(key, appId) {
    MemoryStorageUtils.removeItem(key, appId);
    SessionStorageUtils.removeItem(key);
}
exports.removeItem = removeItem;
//# sourceMappingURL=StorageUtils.js.map

/***/ }),

/***/ 2720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var memoryStorage = new Map();
function clear(appId) {
    memoryStorage.delete(appId);
}
exports.clear = clear;
function setItem(key, value, appId) {
    var map = memoryStorage.get(appId) || new Map();
    map.set(key, value);
    memoryStorage.set(appId, map);
}
exports.setItem = setItem;
function getItem(key, appId) {
    var map = memoryStorage.get(appId);
    return map ? map.get(key) : undefined;
}
exports.getItem = getItem;
function removeItem(key, appId) {
    var map = memoryStorage.get(appId);
    if (map) {
        map.delete(key);
    }
}
exports.removeItem = removeItem;
//# sourceMappingURL=MemoryStorageUtils.js.map

/***/ }),

/***/ 2721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function clear() {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.clear();
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.clear = clear;
function setItem(key, value) {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.setItem(key, value);
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.setItem = setItem;
function getItem(key) {
    if (window.sessionStorage) {
        try {
            var val = window.sessionStorage.getItem(key);
            return val === null ? undefined : val;
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
    return undefined;
}
exports.getItem = getItem;
function removeItem(key) {
    if (window.sessionStorage) {
        try {
            window.sessionStorage.removeItem(key);
        }
        catch (ex) {
            // We're ok with this not being supported
        }
    }
}
exports.removeItem = removeItem;
//# sourceMappingURL=SessionStorageUtils.js.map

/***/ }),

/***/ 2722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getUrlParameter(name, searchString) {
    if (searchString === void 0) { searchString = window.location.search; }
    var param = searchString
        .substr(1)
        .split("&")
        .map(function (e) { return e.split("=").map(function (f) { return decodeURIComponent(f); }); })
        .filter(function (u) { return u[0] === name; });
    return param[0] && param[0][1];
}
exports.getUrlParameter = getUrlParameter;
//# sourceMappingURL=UrlUtils.js.map

/***/ }),

/***/ 2723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authToken_1 = __webpack_require__(2647);
var authUtils_1 = __webpack_require__(2649);
var GET_AUTH_TOKEN_SCENARIO = "LokiGetAuthToken";
var GET_AUTH_TOKEN_FAILED = "LokiGetAuthTokenFailed";
/**
 * A guy you need to ask to getAuthToken and it will keep your worries away
 */
var AuthTokenProvider = (function () {
    function AuthTokenProvider(getAppId, refreshAuthToken, logger, runWithLogMonitor, authTokenType, loggingFeature) {
        if (authTokenType === void 0) { authTokenType = authToken_1.AuthToken; }
        if (loggingFeature === void 0) { loggingFeature = "RESTAuthToken"; }
        this.getAppId = getAppId;
        this.refreshAuthToken = refreshAuthToken;
        this.logger = logger;
        this.runWithLogMonitor = runWithLogMonitor;
        this.authTokenType = authTokenType;
        this.loggingFeature = loggingFeature;
        this.getAuthToken();
    }
    AuthTokenProvider.prototype.getAuthToken = function () {
        var _this = this;
        // Try getting a valid token we already have
        if (this.authToken && this.authToken.isValid()) {
            return Promise.resolve(this.authToken);
        }
        // Try getting the token from cache
        this.authToken = new this.authTokenType(authUtils_1.getAuthToken(this.getAppId()), this.loggingFeature, this.logger);
        if (this.authToken.isValid()) {
            return Promise.resolve(this.authToken);
        }
        this.authPromise =
            this.authPromise ||
                new Promise(function (resolve, reject) {
                    if (_this.runWithLogMonitor) {
                        _this.runWithLogMonitor({
                            scenarioName: GET_AUTH_TOKEN_SCENARIO,
                            feature: _this.loggingFeature,
                            operation: function () { return _this.authToken.refresh(_this.refreshAuthToken); },
                            successAction: function (token) {
                                _this.onRefreshAuthTokenSuccess(token);
                                resolve(token);
                            },
                            errorAction: function (reason) {
                                _this.onRefreshAuthTokenError(reason);
                                reject(reason);
                            },
                            treatAsExpectedError: function (error) {
                                return !!navigator && !navigator.onLine;
                            }
                        });
                    }
                    else {
                        _this.authToken
                            .refresh(_this.refreshAuthToken)
                            .then(function (token) {
                            _this.onRefreshAuthTokenSuccess(token);
                            resolve(token);
                        })
                            .catch(function (reason) {
                            _this.onRefreshAuthTokenError(reason);
                            reject(reason);
                        });
                    }
                });
        return this.authPromise;
    };
    AuthTokenProvider.prototype.onRefreshAuthTokenSuccess = function (newToken) {
        this.authPromise = undefined;
        authUtils_1.setAuthToken(this.getAppId(), newToken.getValue() || "");
    };
    AuthTokenProvider.prototype.onRefreshAuthTokenError = function (error) {
        this.authPromise = undefined;
        if (this.logger) {
            this.logger.logError(GET_AUTH_TOKEN_FAILED, this.loggingFeature, { message: error });
        }
    };
    return AuthTokenProvider;
}());
exports.AuthTokenProvider = AuthTokenProvider;
//# sourceMappingURL=authTokenProvider.js.map

/***/ }),

/***/ 2724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getClientAccessTokenOperation_1 = __webpack_require__(2678);
var Utils_1 = __webpack_require__(362);
var getClientAccessTokenRequest_1 = __webpack_require__(2680);
var LokiAuthTokenId = '94c63fef-13a3-47bc-8074-75af8c65887a';
function getLokiAuthTokenAsync() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, results, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: Utils_1.getJsonRequestHeader(),
                        Body: getClientAccessTokenRequest_1.default({
                            TokenRequests: [
                                {
                                    __type: 'TokenRequest:#Exchange',
                                    Id: LokiAuthTokenId,
                                    TokenType: 'Loki',
                                },
                            ],
                        }),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getClientAccessTokenOperation_1.default(request)];
                case 2:
                    results = _a.sent();
                    if (results && results.Body.ResponseMessages.Items[0].ResponseClass == 'Success') {
                        return [2 /*return*/, results.Body.ResponseMessages.Items[0].Token.TokenValue];
                    }
                    return [2 /*return*/, null];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.default = getLokiAuthTokenAsync;
//# sourceMappingURL=getLokiAuthTokenAsync.js.map

/***/ }),

/***/ 2725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// This endpoint is used to test that Loki is working end to end
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var lokiRequest_1 = __webpack_require__(2726);
function getUserInfo(userSmtp) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var path, queryParameters, response, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    path = 'api/beta/userinfo';
                    queryParameters = {
                        userSmtp: userSmtp,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, lokiRequest_1.lokiRequest('GET', path, queryParameters)];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        return [2 /*return*/, response.json()];
                    }
                    return [2 /*return*/, Promise.reject(response.status)];
                case 3:
                    error_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getUserInfo = getUserInfo;
//# sourceMappingURL=userInfoProvider.js.map

/***/ }),

/***/ 2726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var fetchLokiConfigAsync_1 = __webpack_require__(2727);
var lokiContext = __webpack_require__(2612);
var requestAuthTokenHandler_1 = __webpack_require__(2646);
function lokiRequest(method, path, queryParameters, body, headers) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var config, authToken, url, requestInit;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchLokiConfigAsync_1.fetchLokiConfigAsync()];
                case 1:
                    config = _a.sent();
                    return [4 /*yield*/, requestAuthTokenHandler_1.getAuthToken()];
                case 2:
                    authToken = (_a.sent()).getValue();
                    if (!headers) {
                        headers = new Headers();
                    }
                    headers.set('Accept', 'application/json');
                    headers.set('Content-Type', 'application/json');
                    headers.set('authorization', "Bearer " + authToken);
                    headers.set('X-ClientCorrelationId', lokiContext.clientCorrelationId);
                    headers.set('X-ClientType', lokiContext.clientType);
                    headers.set('X-ClientScenario', lokiContext.clientScenario);
                    headers.set('X-RefererUrl', '');
                    url = addQueryParametersToUrl(config.LokiUrl + path, queryParameters);
                    requestInit = {
                        method: method,
                        headers: headers,
                        body: body,
                    };
                    return [2 /*return*/, fetch(url, requestInit)];
            }
        });
    });
}
exports.lokiRequest = lokiRequest;
function addQueryParametersToUrl(url, queryParameters) {
    var parametersKeys = Object.keys(queryParameters);
    if (parametersKeys.length === 0) {
        return url;
    }
    var parameters = [];
    parametersKeys.forEach(function (key) {
        var value = queryParameters[key];
        parameters.push(key + '=' + encodeURIComponent(value || ''));
    });
    return url + '?' + parameters.join('&');
}
//# sourceMappingURL=lokiRequest.js.map

/***/ }),

/***/ 2727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getLokiBootstrapperConfig_1 = __webpack_require__(2645);
var live_persona_card_bootstrapper_1 = __webpack_require__(2650);
var lokiConfig = undefined;
function fetchLokiConfigAsync() {
    if (lokiConfig) {
        return Promise.resolve(lokiConfig);
    }
    var bootstrapperConfig = getLokiBootstrapperConfig_1.getLokiBootstrapperConfig();
    return live_persona_card_bootstrapper_1.fetchLokiConfig(bootstrapperConfig).then(function (config) {
        lokiConfig = config;
        return lokiConfig;
    });
}
exports.fetchLokiConfigAsync = fetchLokiConfigAsync;
//# sourceMappingURL=fetchLokiConfigAsync.js.map

/***/ }),

/***/ 3678:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4836);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var ContextualMenu_1 = __webpack_require__(677);
var Icon_1 = __webpack_require__(43);
var owa_mail_search_actions_1 = __webpack_require__(218);
var owa_mail_search_store_1 = __webpack_require__(41);
var Store_1 = __webpack_require__(17);
var searchViewConstants_1 = __webpack_require__(659);
var getUserConfiguration_1 = __webpack_require__(9);
var folderNameToId_1 = __webpack_require__(35);
var owa_mail_strings_1 = __webpack_require__(22);
var React = __webpack_require__(3);
var styles = __webpack_require__(4832);
var FiltersContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(FiltersContextMenu, _super);
    function FiltersContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.stopPropagation();
                        return [4 /*yield*/, owa_mail_search_store_1.lazySetShowFiltersMenu.importAndExecute(false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Handle change in folder scope from the filter context menu
         */
        _this.changeFolderScope = function (evt, newFolderId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // set the new folder scope
                    return [4 /*yield*/, owa_mail_search_actions_1.lazyChangeFolderScope(newFolderId)];
                    case 1:
                        // set the new folder scope
                        _a.sent();
                        this.props.onFolderScopeChanged();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    FiltersContextMenu.prototype.render = function () {
        return (React.createElement(ContextualMenu_1.ContextualMenu, { shouldFocusOnMount: true, target: this.props.targetElement, className: styles.filtersContextMenu, directionalHintFixed: true, gapSpace: 2, onDismiss: this.onDismiss, directionalHint: 6 /* bottomRightEdge */, items: this.searchMenuItems }));
    };
    Object.defineProperty(FiltersContextMenu.prototype, "searchMenuItems", {
        get: function () {
            var _this = this;
            var msgFolderRootId = folderNameToId_1.default('msgfolderroot');
            // Add some distinguished folders and a root folder
            var folderIds = [
                msgFolderRootId,
                folderNameToId_1.default('inbox'),
                folderNameToId_1.default('deleteditems'),
                folderNameToId_1.default('sentitems'),
            ];
            // Add the archive folder if user has one set
            var archiveFolderId = getUserConfiguration_1.default().UserOptions.ArchiveFolderId;
            if (archiveFolderId) {
                folderIds.push(archiveFolderId);
            }
            // Add the current folder scope if not there already (Inbox for e.g. will be pre-popualated above)
            var currentFolderScopeId = owa_mail_search_store_1.searchStore.staticFolderScopeId;
            if (folderIds.indexOf(currentFolderScopeId) == -1) {
                folderIds.push(currentFolderScopeId);
            }
            // Create the filter context menus
            var items = [];
            var _loop_1 = function (i) {
                var folderId = folderIds[i];
                var displayName = folderId == msgFolderRootId
                    ? owa_mail_strings_1.default.allFolders
                    : Store_1.default.folders.folderTable.get(folderId).DisplayName;
                items.push({
                    key: folderId,
                    name: displayName,
                    canCheck: true,
                    isChecked: folderId == owa_mail_search_store_1.searchStore.staticFolderScopeId,
                    onRender: function () { return (React.createElement("div", { "data-is-focusable": true, className: styles.filterMenuItem, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, onClick: function (evt) { return _this.changeFolderScope(evt, folderId); } },
                        React.createElement("div", { className: styles.checkMarkContainer }, folderId == owa_mail_search_store_1.searchStore.staticFolderScopeId && (React.createElement(Icon_1.Icon, { iconName: "CheckMark" /* CheckMark */ }))),
                        React.createElement("div", { className: styles.folderName }, displayName))); },
                });
            };
            for (var i = 0; i < folderIds.length; i++) {
                _loop_1(i);
            }
            return items;
        },
        enumerable: true,
        configurable: true
    });
    FiltersContextMenu = tslib_1.__decorate([
        mobx_react_1.observer
    ], FiltersContextMenu);
    return FiltersContextMenu;
}(React.Component));
exports.default = FiltersContextMenu;
//# sourceMappingURL=FiltersContextMenu.js.map

/***/ }),

/***/ 4832:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4833);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4833:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".N_2okZr7H3C17z86qQDKK{width:252px}._1QPurLuNzCpmyVENszFKyb{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:32px;line-height:32px;cursor:pointer}html[dir] ._1QPurLuNzCpmyVENszFKyb{padding:0 6px;background:#fff}html[dir] ._1QPurLuNzCpmyVENszFKyb:focus,html[dir] ._1QPurLuNzCpmyVENszFKyb:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}._2d1Xixp6OYBhYbGEY3uNS3{width:24px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.sK4Be6HRpXMUFrdmyOh_j{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}html[dir] .sK4Be6HRpXMUFrdmyOh_j{margin:0 4px}", ""]);

// exports
exports.locals = {
	"filtersContextMenu": "N_2okZr7H3C17z86qQDKK",
	"filterMenuItem": "_1QPurLuNzCpmyVENszFKyb",
	"checkMarkContainer": "_2d1Xixp6OYBhYbGEY3uNS3",
	"folderName": "sK4Be6HRpXMUFrdmyOh_j"
};

/***/ }),

/***/ 4834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var Persona_1 = __webpack_require__(234);
var PersonaControl_1 = __webpack_require__(673);
var PersonaCardBehavior_1 = __webpack_require__(2655);
var React = __webpack_require__(3);
var styles = __webpack_require__(3678);
var PersonaPill = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaPill, _super);
    function PersonaPill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PersonaPill.prototype.render = function () {
        return (React.createElement("div", { className: styles.personaPill, onMouseEnter: this.props.onPersonaCardBehaviorMouseEnter, onMouseLeave: this.props.onPersonaCardBehaviorMouseLeave },
            React.createElement(PersonaControl_1.default, { name: this.props.name, emailAddress: this.props.emailAddress, size: Persona_1.PersonaSize.extraExtraSmall }),
            React.createElement("div", { className: styles.personaPillText }, this.props.name)));
    };
    PersonaPill = tslib_1.__decorate([
        PersonaCardBehavior_1.personaCardBehavior,
        mobx_react_1.observer
    ], PersonaPill);
    return PersonaPill;
}(React.Component));
exports.default = PersonaPill;
//# sourceMappingURL=PersonaPill.js.map

/***/ }),

/***/ 4836:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._31N5aqF1u-BIXmreIK65B0{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden;height:24px}._31N5aqF1u-BIXmreIK65B0 .lpc-hoverTarget{overflow:hidden}.MjW8axjU1h5Kcpj-T-Q6q{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-width:48px}html[dir] .MjW8axjU1h5Kcpj-T-Q6q{background-color:\"[theme:neutralLighter, default:#f4f4f4]\";border-radius:15px}html[dir=ltr] .MjW8axjU1h5Kcpj-T-Q6q{margin-right:5px}html[dir=rtl] .MjW8axjU1h5Kcpj-T-Q6q{margin-left:5px}html[dir] .MjW8axjU1h5Kcpj-T-Q6q:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}._3S9jlzMYq75LLMuqg-ze8w{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1GRQms06mswKIPRMAL0Ty_{line-height:24px;color:\"[theme:black, default:#000000]\";font-size:14px;font-weight:400;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}html[dir=ltr] ._1GRQms06mswKIPRMAL0Ty_{margin:0 5px 0 8px}html[dir=rtl] ._1GRQms06mswKIPRMAL0Ty_{margin:0 8px 0 5px}._3-4tHZFWr0Ks6vr3NRJCuS{width:24px;height:24px}html[dir] ._3-4tHZFWr0Ks6vr3NRJCuS{border-radius:50%;padding:0}._3-4tHZFWr0Ks6vr3NRJCuS:hover{cursor:pointer}._3-4tHZFWr0Ks6vr3NRJCuS ._15s9-4kANT9nHIfS7OG3hs{font-size:12px;font-weight:400;color:\"[theme:black, default:#000000]\"}html[dir] .MjW8axjU1h5Kcpj-T-Q6q:hover ._3-4tHZFWr0Ks6vr3NRJCuS{background-color:\"[theme:neutralTertiaryAlt, default:#c8c8c8]\"}", ""]);

// exports
exports.locals = {
	"personaPillWell": "_31N5aqF1u-BIXmreIK65B0",
	"personaPillBox": "MjW8axjU1h5Kcpj-T-Q6q",
	"personaPill": "_3S9jlzMYq75LLMuqg-ze8w",
	"personaPillText": "_1GRQms06mswKIPRMAL0Ty_",
	"removePersonaIcon": "_3-4tHZFWr0Ks6vr3NRJCuS",
	"cancelIcon": "_15s9-4kANT9nHIfS7OG3hs"
};

/***/ }),

/***/ 4837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var owa_mail_search_store_1 = __webpack_require__(41);
var owa_mail_search_view_1 = __webpack_require__(607);
var Button_1 = __webpack_require__(62);
var styles = __webpack_require__(3678);
var PersonaPillWell = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaPillWell, _super);
    function PersonaPillWell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PersonaPillWell.prototype.renderPersonaItems = function () {
        var _this = this;
        var personaItems = [];
        var length = owa_mail_search_store_1.searchStore.personaPillIds.length;
        var _loop_1 = function (i) {
            var personaPillId = owa_mail_search_store_1.searchStore.personaPillIds[i];
            var persona = owa_mail_search_store_1.searchStore.personaPillSuggestions.get(personaPillId);
            personaItems.push(React.createElement("div", { key: i.toString(), className: styles.personaPillBox },
                React.createElement(owa_mail_search_view_1.PersonaPill, { name: persona.DisplayName, emailAddress: persona.EmailAddresses[0], personaPillId: personaPillId, onRemoveClick: this_1.props.onRemovePersona, personaType: 'User' }),
                React.createElement(Button_1.IconButton, { className: styles.removePersonaIcon, iconProps: {
                        iconName: "Cancel" /* Cancel */,
                        styles: {
                            root: styles.cancelIcon,
                        },
                    }, onClick: function () { return _this.props.onRemovePersona(personaPillId); } })));
        };
        var this_1 = this;
        for (var i = 0; i < length; i++) {
            _loop_1(i);
        }
        return personaItems;
    };
    PersonaPillWell.prototype.render = function () {
        return React.createElement("div", { className: styles.personaPillWell }, this.renderPersonaItems());
    };
    PersonaPillWell = tslib_1.__decorate([
        mobx_react_1.observer
    ], PersonaPillWell);
    return PersonaPillWell;
}(React.Component));
exports.default = PersonaPillWell;
//# sourceMappingURL=PersonaPillWell.js.map

/***/ }),

/***/ 4838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Icon_1 = __webpack_require__(43);
var mobx_1 = __webpack_require__(15);
var mobx_react_1 = __webpack_require__(11);
var Persona_1 = __webpack_require__(234);
var owa_analytics_1 = __webpack_require__(12);
var owa_mail_search_store_1 = __webpack_require__(41);
var saveSearch_1 = __webpack_require__(1628);
var getSuggestionsSet_1 = __webpack_require__(230);
var PersonaControl_1 = __webpack_require__(673);
var React = __webpack_require__(3);
var ContextualMenu_1 = __webpack_require__(677);
var searchConstants_1 = __webpack_require__(586);
var searchViewConstants_1 = __webpack_require__(659);
var owa_mail_search_store_2 = __webpack_require__(41);
var owa_mail_feature_flags_1 = __webpack_require__(23);
var searchBoxStyles = __webpack_require__(663);
var styles = __webpack_require__(4839);
var classNames = __webpack_require__(30);
var MAX_SUGGESTIONS_TO_SHOW = 6;
var START_MATCH_DELIMITER = String.fromCharCode(0xe000); // The server uses this char to mark start of highlighting.
var END_MATCH_DELIMITER = String.fromCharCode(0xe001); // The server uses this char to mark end of highlighting.
var SPACE_REGEX = /^\s/;
var NONBREAKING_SPACE_CHAR = String.fromCharCode(160);
var SuggestionsContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionsContextMenu, _super);
    function SuggestionsContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.suggestions = [];
        _this.createPinnedItem = function (query) {
            return {
                key: query,
                name: query,
                className: styles.keywordSuggestion,
                onRender: function () { return (React.createElement("div", { className: styles.pinnedItem, tabIndex: 0 },
                    React.createElement("div", { tabIndex: 0, key: query, className: styles.pinnedKeyword, title: query, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, onMouseDown: function () {
                            var eventName = owa_mail_search_store_1.datapoints.ExecuteSaveSearch.datapoint.name;
                            owa_analytics_1.logUsage(eventName);
                            _this.props.onTextSuggestionClick(query);
                        } },
                        React.createElement(Icon_1.Icon, { className: searchBoxStyles.suggestionHistoryClockIcon, iconName: "Pinned" /* Pinned */ }),
                        React.createElement("div", { className: styles.keywordNonMatchSuggestion }, query)),
                    React.createElement("div", { tabIndex: 0, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, onClick: function () {
                            return _this.props.onUnpinSearchClicked(query, 'SearchBoxSuggestionDropDown');
                        } },
                        React.createElement(Icon_1.Icon, { className: classNames(searchBoxStyles.pinIcon, styles.pinActionIconContainer), iconName: "Pinned" /* Pinned */, title: 'Unpin Search' })))); },
            };
        };
        _this.createKeywordSuggestionItem = function (traceId, suggestion, index) {
            var matchText = null;
            var notMatchText = suggestion.DisplayText;
            var startMatchIndex = suggestion.DisplayText.indexOf(START_MATCH_DELIMITER);
            var endMatchIndex = suggestion.DisplayText.lastIndexOf(END_MATCH_DELIMITER);
            var title = notMatchText;
            if (endMatchIndex > 0) {
                matchText = suggestion.DisplayText.substring(startMatchIndex + 1, endMatchIndex);
                // If the first character of the notMatchText is a space,
                // replace it with a non-breaking space, since any other whitespace
                // will be stripped when notMatchText is rendered.
                notMatchText = suggestion.DisplayText.substr(endMatchIndex + 1).replace(SPACE_REGEX, NONBREAKING_SPACE_CHAR);
            }
            return {
                key: suggestion.DisplayText,
                name: suggestion.DisplayText,
                className: owa_mail_search_store_1.searchStore.selectedSuggestionIndex == index ? styles.suggestionSelected : '',
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.DisplayText, className: styles.keywordSuggestion, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onTextSuggestionClick(suggestion.QueryText);
                        if (owa_mail_feature_flags_1.isMailFeatureEnabled('sea-qf')) {
                            owa_mail_search_store_2.lazyLogEntityClicked.importAndExecute(traceId, suggestion.ReferenceId);
                        }
                    }, title: title },
                    React.createElement(Icon_1.Icon, { className: searchBoxStyles.suggestionHistoryClockIcon, iconName: "Clock" /* Clock */ }),
                    React.createElement("div", { className: styles.keywordMatchSuggestion }, matchText),
                    React.createElement("div", { className: styles.keywordNonMatchSuggestion }, notMatchText))); },
            };
        };
        _this.createPeopleSuggestionItem = function (traceId, suggestion, index) {
            return {
                key: suggestion.ReferenceId,
                name: suggestion.DisplayName,
                className: owa_mail_search_store_1.searchStore.selectedSuggestionIndex == index ? styles.suggestionSelected : '',
                onRender: function () { return (React.createElement("div", { tabIndex: 0, key: suggestion.ReferenceId, className: styles.personaSuggestion, "data-click-source": searchViewConstants_1.SEARCH_BOX_SOURCE, 
                    // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
                    onMouseDown: function () {
                        _this.props.onPeopleSuggestionClick(suggestion);
                        if (owa_mail_feature_flags_1.isMailFeatureEnabled('sea-qf')) {
                            owa_mail_search_store_2.lazyLogEntityClicked.importAndExecute(traceId, suggestion.ReferenceId);
                        }
                    } },
                    React.createElement(PersonaControl_1.default, { name: suggestion.DisplayName, emailAddress: suggestion.EmailAddresses[0], size: Persona_1.PersonaSize.size28, showPresence: false, showPersonaDetails: true }))); },
            };
        };
        return _this;
    }
    SuggestionsContextMenu.prototype.render = function () {
        return (React.createElement(ContextualMenu_1.ContextualMenu, { useTargetWidth: true, shouldFocusOnMount: false, target: this.props.targetElement, gapSpace: 2, directionalHintFixed: true, directionalHint: 4 /* bottomLeftEdge */, items: this.searchMenuItems }));
    };
    Object.defineProperty(SuggestionsContextMenu.prototype, "searchMenuItems", {
        get: function () {
            var _this = this;
            var items = this.suggestions;
            var suggestionSet = getSuggestionsSet_1.default();
            if (suggestionSet && suggestionSet.IsComplete) {
                items = [];
                var savedSearches = saveSearch_1.getSavedSearches();
                if (this.props.shouldShowPinSearchIcon && savedSearches) {
                    // first render the pinned items
                    savedSearches.forEach(function (query) {
                        items.push(_this.createPinnedItem(query));
                    });
                    items.push({
                        key: 'divider_1',
                        itemType: ContextualMenu_1.ContextualMenuItemType.Divider,
                    });
                }
                // Show people suggestions only when we have not already selected 2 persona suggestions
                var shouldShowPeopleSuggestions_1 = owa_mail_search_store_1.searchStore.personaPillIds.length < searchConstants_1.PERSONA_PILL_LIMIT;
                suggestionSet.Suggestions.slice(0, MAX_SUGGESTIONS_TO_SHOW).map(function (suggestion, index) {
                    if (suggestion.kind == searchConstants_1.PEOPLE_KIND_SUGGESTION && shouldShowPeopleSuggestions_1) {
                        items.push(_this.createPeopleSuggestionItem(suggestionSet.TraceId, suggestion, index));
                    }
                    else if (suggestion.kind == searchConstants_1.KEYWORD_KIND_SUGGESTION) {
                        items.push(_this.createKeywordSuggestionItem(suggestionSet.TraceId, suggestion, index));
                    }
                });
                if (owa_mail_feature_flags_1.isMailFeatureEnabled('sea-qf')) {
                    owa_mail_search_store_2.lazyLogResponseRendered.importAndExecute(suggestionSet.TraceId);
                }
            }
            return (this.suggestions = items);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], SuggestionsContextMenu.prototype, "searchMenuItems", null);
    SuggestionsContextMenu = tslib_1.__decorate([
        mobx_react_1.observer
    ], SuggestionsContextMenu);
    return SuggestionsContextMenu;
}(React.Component));
exports.default = SuggestionsContextMenu;
//# sourceMappingURL=SuggestionsContextMenu.js.map

/***/ }),

/***/ 4839:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4840);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4840:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1Rsujht70wUg7eKQx_wVgi,._2YMOL87bWjJ3qFvLfAuRdM,.DrFSxgvkwMJ2d9ZT5fPD,.R9DFRXWoCkTKHEgm6txwy{display:-webkit-box;display:-ms-flexbox;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;height:36px;line-height:36px;cursor:pointer;display:flex;align-items:center}html[dir] ._1Rsujht70wUg7eKQx_wVgi:hover,html[dir] ._2YMOL87bWjJ3qFvLfAuRdM:hover,html[dir] .DrFSxgvkwMJ2d9ZT5fPD:hover,html[dir] .R9DFRXWoCkTKHEgm6txwy:hover{background:\"[theme:neutralLight, default:#eaeaea]\"}._1Rsujht70wUg7eKQx_wVgi:hover ._3fcBQh3b08sZ8jGpK9PcPO,._2YMOL87bWjJ3qFvLfAuRdM:hover ._3fcBQh3b08sZ8jGpK9PcPO,.DrFSxgvkwMJ2d9ZT5fPD:hover ._3fcBQh3b08sZ8jGpK9PcPO,.R9DFRXWoCkTKHEgm6txwy:hover ._3fcBQh3b08sZ8jGpK9PcPO{display:inline}html[dir=ltr] ._1Rsujht70wUg7eKQx_wVgi,html[dir=ltr] .DrFSxgvkwMJ2d9ZT5fPD{padding-right:24px}html[dir=rtl] ._1Rsujht70wUg7eKQx_wVgi,html[dir=rtl] .DrFSxgvkwMJ2d9ZT5fPD{padding-left:24px}html[dir] .aA6Yp6F5UOARNz7dgvF8Q{background:\"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] ._2YMOL87bWjJ3qFvLfAuRdM{padding-left:8px}html[dir=rtl] ._2YMOL87bWjJ3qFvLfAuRdM{padding-right:8px}._2IjVvnyzcOPoM80tgbT_NG,._3B_ZwEKtE3zQ4gekCN79kx,._15fOPnDwa7bfL-tF_jEOC8{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._3B_ZwEKtE3zQ4gekCN79kx{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-weight:600}._3fcBQh3b08sZ8jGpK9PcPO{cursor:pointer;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;display:none}._30yd7e5VD4sYTYyPhlDT7N{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}._1Rsujht70wUg7eKQx_wVgi{width:100%}", ""]);

// exports
exports.locals = {
	"searchSuggestion": "R9DFRXWoCkTKHEgm6txwy",
	"keywordSuggestion": "DrFSxgvkwMJ2d9ZT5fPD",
	"pinnedKeyword": "_1Rsujht70wUg7eKQx_wVgi",
	"personaSuggestion": "_2YMOL87bWjJ3qFvLfAuRdM",
	"pinActionIconContainer": "_3fcBQh3b08sZ8jGpK9PcPO",
	"suggestionSelected": "aA6Yp6F5UOARNz7dgvF8Q",
	"keywordPartialSuggestion": "_2IjVvnyzcOPoM80tgbT_NG",
	"keywordMatchSuggestion": "_3B_ZwEKtE3zQ4gekCN79kx",
	"keywordNonMatchSuggestion": "_15fOPnDwa7bfL-tF_jEOC8",
	"pinnedItem": "_30yd7e5VD4sYTYyPhlDT7N"
};

/***/ }),

/***/ 4841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_mail_search_store_1 = __webpack_require__(41);
var owa_mail_search_actions_1 = __webpack_require__(218);
var Button_1 = __webpack_require__(62);
var Dialog_1 = __webpack_require__(1742);
var React = __webpack_require__(3);
var Checkbox_1 = __webpack_require__(2639);
var mobx_react_1 = __webpack_require__(11);
var Link_1 = __webpack_require__(2123);
var sendSearchFeedback_1 = __webpack_require__(4842);
var TextField_1 = __webpack_require__(1741);
var styles = __webpack_require__(4843);
var classNames = __webpack_require__(30);
// this feature can NEVER ship beyond MSIT since it contains PII,
// so we store our strings locally (so that they don't get localized)
var unlocalizedStrings = {
    dialogTitle: 'What issues did you encounter?',
    feedbackCommentsPlaceholder: 'Tell us what happened or how we can improve',
    primaryButtonText: 'Provide feedback',
    feedbackLauncherText: 'Search issues?',
    feedbackLauncherLink: 'Submit feedback',
};
var SearchInContextFeedbackDialog = /** @class */ (function (_super) {
    tslib_1.__extends(SearchInContextFeedbackDialog, _super);
    function SearchInContextFeedbackDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCategoryCheckboxes = function () {
            return owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.feedbackCategories.map(function (category, i) { return (React.createElement(Checkbox_1.Checkbox, { key: i, checked: category.checked, label: category.label, className: styles.feedbackCategoryCheckbox, onChange: function (ev, isChecked) {
                    return owa_mail_search_actions_1.lazyUpdateSearchInContextFeedbackCategoryCheckbox(i, isChecked);
                } })); });
        };
        _this.onProvideFeedback = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                sendSearchFeedback_1.default();
                owa_mail_search_actions_1.lazySetIsSearchInContextFeedbackDialogShown(false);
                return [2 /*return*/];
            });
        }); };
        _this.onInput = function (newValue) {
            owa_mail_search_actions_1.lazyUpdateSearchInContextFeedbackDialogComments(newValue);
        };
        return _this;
    }
    SearchInContextFeedbackDialog.prototype.render = function () {
        return (React.createElement("div", { className: classNames(this.props.cssClass, styles.linkContainer) },
            React.createElement("span", { className: styles.feedbackLauncher },
                unlocalizedStrings.feedbackLauncherText,
                "\u00A0",
                React.createElement(Link_1.Link, { onClick: function () {
                        owa_mail_search_actions_1.lazyResetSearchInContextFeedbackViewState();
                        owa_mail_search_actions_1.lazySetIsSearchInContextFeedbackDialogShown(true);
                    } }, unlocalizedStrings.feedbackLauncherLink)),
            owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.isFeedbackDialogShown && (React.createElement(Dialog_1.Dialog, { hidden: false, onDismiss: function () { return owa_mail_search_actions_1.lazySetIsSearchInContextFeedbackDialogShown(false); }, title: unlocalizedStrings.dialogTitle, containerClassName: styles.dialogContainer, contentClassName: styles.content },
                this.renderCategoryCheckboxes(),
                React.createElement(TextField_1.TextField, { multiline: true, value: owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.feedbackComments, onChanged: this.onInput, className: styles.textAreaContainer, inputClassName: styles.textArea, placeholder: unlocalizedStrings.feedbackCommentsPlaceholder }),
                React.createElement(Dialog_1.DialogFooter, null,
                    React.createElement(Button_1.PrimaryButton, { onClick: this.onProvideFeedback }, unlocalizedStrings.primaryButtonText))))));
    };
    SearchInContextFeedbackDialog = tslib_1.__decorate([
        mobx_react_1.observer
    ], SearchInContextFeedbackDialog);
    return SearchInContextFeedbackDialog;
}(React.Component));
exports.default = SearchInContextFeedbackDialog;
//# sourceMappingURL=SearchInContextFeedbackDialog.js.map

/***/ }),

/***/ 4842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_mail_search_store_1 = __webpack_require__(41);
var owa_session_store_1 = __webpack_require__(151);
var owa_automated_message_1 = __webpack_require__(705);
exports.default = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var sendAutomatedMessage, messageDetails, timeFormat;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, owa_automated_message_1.lazySendAutomatedMessage.import()];
            case 1:
                sendAutomatedMessage = _a.sent();
                messageDetails = {
                    subject: 'OWA 3S Query Feedback',
                    message: buildMessage(),
                    to: ['owa3squeryfeedback@service.microsoft.com'],
                    attachments: null,
                };
                timeFormat = owa_session_store_1.getUserConfiguration().UserOptions.TimeFormat;
                sendAutomatedMessage(messageDetails, timeFormat);
                return [2 /*return*/];
        }
    });
}); };
var buildMessage = function () {
    var feedbackCategories = owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.feedbackCategories
        .map(convertFeedbackCategoryToChecklistItem)
        .join('\n');
    var searchInstrumentation = convertAllInstrumentationToTable(owa_mail_search_store_1.searchStore.searchRequestInstrumentation.reverse());
    var message = "<h2>Categories</h2>" + feedbackCategories + " \n\n\n <h2>Verbatim</h2>" + owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.feedbackComments + " \n\n\n <h2>Search History</h2>" + searchInstrumentation.replace(/\n/g, '');
    return message.replace(/\n/g, '<br />');
};
var convertFeedbackCategoryToChecklistItem = function (c) {
    return (c.checked ? String.fromCharCode(9745) : String.fromCharCode(9744)) + "&nbsp;" + c.label;
};
var convertAllInstrumentationToTable = function (instrumentation) {
    return instrumentation == null || instrumentation.length == 0
        ? null
        : "<table border=\"1\">\n            " + extractInstrumentationTableHeaders(instrumentation) + "\n            " + convertInstrumentationToTableRows(instrumentation) + "\n        </table>";
};
var extractInstrumentationTableHeaders = function (instrumentation) {
    return "<thead><tr>\n        " + Object.keys(instrumentation[0])
        .map(function (key) { return "<th>" + key + "</th>"; })
        .join('') + "\n    </tr></thead>";
};
var convertInstrumentationToTableRows = function (instrumentation) {
    return instrumentation
        .map(function (e) {
        return "<tr>\n                    " + Object.keys(e)
            .map(function (key) { return convertInstrumentationFieldToTableCell(e[key]); })
            .join('') + "\n                </tr>";
    })
        .join('');
};
var convertInstrumentationFieldToTableCell = function (field) {
    if (!field) {
        return '<td></td>';
    }
    else if (field instanceof Array) {
        return "<td>" + field.join(',') + "</td>";
    }
    else if (field instanceof Date) {
        return "<td>" + field.toISOString() + "</td>";
    }
    else {
        return "<td>" + field.toString() + "</td>";
    }
};
//# sourceMappingURL=sendSearchFeedback.js.map

/***/ }),

/***/ 4843:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4844);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4844:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._1scz2mzk7WeH_ny5oYrv7R{margin-top:-4px}._1r_-jalLgbkphbKMXew0ix{font-size:11px}html[dir] ._1r_-jalLgbkphbKMXew0ix{margin:0 12px}._3yvFAGUczEqkCkuyekd5ey{font-size:14px;font-weight:400;max-width:600px;max-height:600px;width:400px}.JPrX56_79sSCmwPZYnXil{font-size:14px;font-weight:400;max-height:80%;overflow:auto}._3r2D7vulZ9b9LezOVnciH8{line-height:30px}html[dir] ._2deIjQ2KfNINseQ4WxAI12{margin:5px 0}._3nnfTyhh3irdXYujP-KZCT{resize:none;height:100px;font-size:14px;font-weight:400;font-size:12px}._3nnfTyhh3irdXYujP-KZCT::-webkit-input-placeholder{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:12px}._3nnfTyhh3irdXYujP-KZCT::-moz-placeholder{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:12px}._3nnfTyhh3irdXYujP-KZCT:-ms-input-placeholder{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:12px}._3nnfTyhh3irdXYujP-KZCT:-moz-placeholder{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:12px}html[dir] .ucC0y83TG0MlWKoznMbv_{border:1px solid \"[theme:neutralTertiary, default:#a6a6a6]\";margin:20px 0 0}", ""]);

// exports
exports.locals = {
	"linkContainer": "_1scz2mzk7WeH_ny5oYrv7R",
	"feedbackLauncher": "_1r_-jalLgbkphbKMXew0ix",
	"dialogContainer": "_3yvFAGUczEqkCkuyekd5ey",
	"content": "JPrX56_79sSCmwPZYnXil",
	"titleText": "_3r2D7vulZ9b9LezOVnciH8",
	"feedbackCategoryCheckbox": "_2deIjQ2KfNINseQ4WxAI12",
	"textArea": "_3nnfTyhh3irdXYujP-KZCT",
	"textAreaContainer": "ucC0y83TG0MlWKoznMbv_"
};

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DialogType;
(function (DialogType) {
    /** Standard dialog */
    DialogType[DialogType["normal"] = 0] = "normal";
    /** Dialog with large header banner */
    DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
    /** Dialog with an 'x' close button in the upper-right corner */
    DialogType[DialogType["close"] = 2] = "close";
})(DialogType = exports.DialogType || (exports.DialogType = {}));
//# sourceMappingURL=DialogContent.types.js.map

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".isOpen_a6c8430f{display:-webkit-box;display:-ms-flexbox;display:flex}.main_a6c8430f{width:288px}.button_a6c8430f.isClose_a6c8430f .ms-Icon.ms-Icon--Cancel{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";font-size:16px}.inner_a6c8430f{padding:0 28px 20px}.header_a6c8430f{position:relative;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.title_a6c8430f{margin:0;font-size:21px;font-weight:100;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";padding:20px 36px 20px 28px}[dir='rtl'] .title_a6c8430f{padding:20px 28px 20px 36px}.topButton_a6c8430f{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;position:absolute;top:0;padding:12px 12px 0 0}[dir='ltr'] .topButton_a6c8430f{right:0}[dir='rtl'] .topButton_a6c8430f{left:0}[dir='rtl'] .topButton_a6c8430f{padding:12px 0 0 12px}.topButton_a6c8430f>*{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.content_a6c8430f{position:relative;width:100%}.content_a6c8430f .ms-Button.ms-Button--compound{margin-bottom:20px}.content_a6c8430f .ms-Button.ms-Button--compound:last-child{margin-bottom:0}.subText_a6c8430f{margin:0 0 20px 0;padding-top:8px;font-size:12px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:300;line-height:1.5;word-wrap:break-word}.actions_a6c8430f{position:relative;width:100%;min-height:24px;line-height:24px;margin:20px 0 0;font-size:0}.actions_a6c8430f .ms-Button{line-height:normal}.actionsRight_a6c8430f{font-size:0}[dir='ltr'] .actionsRight_a6c8430f{text-align:right}[dir='rtl'] .actionsRight_a6c8430f{text-align:left}[dir='ltr'] .actionsRight_a6c8430f{margin-right:-4px}[dir='rtl'] .actionsRight_a6c8430f{margin-left:-4px}.actionsRight_a6c8430f .action_a6c8430f{margin:0px 4px}.isMultiline_a6c8430f .title_a6c8430f{font-size:28px}.isMultiline_a6c8430f .inner_a6c8430f{padding:0 20px 20px}.isLargeHeader_a6c8430f .header_a6c8430f{background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": "}.isLargeHeader_a6c8430f .title_a6c8430f{font-size:28px;font-weight:100;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";padding:26px 28px 28px;margin-bottom:8px}.isLargeHeader_a6c8430f .subText_a6c8430f{font-size:14px}@media (min-width: 480px){.main_a6c8430f{width:auto;min-width:288px;max-width:340px}}\n" }]);
exports.isOpen = "isOpen_a6c8430f";
exports.main = "main_a6c8430f";
exports.button = "button_a6c8430f";
exports.isClose = "isClose_a6c8430f";
exports.inner = "inner_a6c8430f";
exports.header = "header_a6c8430f";
exports.title = "title_a6c8430f";
exports.topButton = "topButton_a6c8430f";
exports.content = "content_a6c8430f";
exports.subText = "subText_a6c8430f";
exports.actions = "actions_a6c8430f";
exports.actionsRight = "actionsRight_a6c8430f";
exports.action = "action_a6c8430f";
exports.isMultiline = "isMultiline_a6c8430f";
exports.isLargeHeader = "isLargeHeader_a6c8430f";
//# sourceMappingURL=Dialog.scss.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.SearchView.js